import * as React from "react";
import { Formatters, Modal } from "@src/components/ui";
import FormInput from "@src/components/ui/FormInput";
import FormSelect from "@src/components/ui/FormSelect";
import FormRadio from "@src/components/ui/FormRadio";
import FormDate from "@src/components/ui/FormDate";
import ModalMateria from "@src/components/frontend/modals/ModalMateria";
import ModalFormazione from "@src/components/frontend/modals/ModalFormazione";
import ModalCompetenza from "@src/components/frontend/modals/ModalCompetenza";
import ModalLingua from "@src/components/frontend/modals/ModalLingua";
import ModalAggiungiScuola from "@src/components/frontend/modals/ModalAggiungiScuola";
import ModalEsperienza from "@src/components/frontend/modals/ModalEsperienza";
import FormCheckBox from "@src/components/ui/FormCheckBox";
import ListItem from "@src/components/ui/ListItem";
import GeoAutocompleteControl from "@src/components/ui/GeoAutocompleteControl";
import MapContainer from "@src/components/ui/MapContainer";
import { route } from "@src/services/browser";
import Modal from "@src/components/ui/Modal";
import ImageEditor from "@src/components/ui/ImageEditor";
import Esperienza from "@src/components/frontend/Esperienza";
import SceltaScuola from "@src/components/frontend/SceltaScuola";
import Message from "@src/components/frontend/Message";
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import { api, user, shared } from "@src/services/api";
import { alert, notify } from "@src/services/notify";
import { classNames, __, __BETA } from "src/services/theme";
import orderBy from "lodash/orderBy";
import prefissi from './prefissi';

interface Props {
    account: number,
    onBack: any
    profilo?: boolean;
}

interface State {
    index: number,
    step: number,
    modal: boolean,
    tmodal: number,
    isRequestLoading: boolean,

    countries: any,
    countryValues: any,
    subjects: any,
    subjectValues: any,
    skills: any,
    skillValues: any,
    languages: any,
    languageValues: any,

    nome?: string,
    cognome?: string,
    data_nascita?: string,
    data_nascita_gg?: string,
    data_nascita_mm?: string,
    data_nascita_yyyy?: string,
    indirizzo?: string,
    comune?: string,
    id_provincia?: number,
    cap?: string,
    nazione?: any,
    sesso?: string,
    telefono_pfx?: string,
    telefono_num?: string,
    _anagrafica_foto?: any,
    automunito?: boolean,
    patente_b?: boolean,
    numero_figli?: any,
    figli?: number[],
    logo_url: any,
    copyTo?: any,

    scuola_frequentata?: any,
    sono_un_genitore?: any,


    _animatore_nome?: string,
    _animatore_cognome?: string,
    _animatore_email?: string,
    _animatore_telefono?: string,
    _animatore_note?: string,

    _preside_nome?: string,
    _preside_cognome?: string,
    _preside_email?: string,
    _preside_telefono?: string,
    _preside_note?: string,

    _segreteria_nome?: string,
    _segreteria_cognome?: string,
    _segreteria_email?: string,
    _segreteria_telefono?: string,
    _segreteria_note?: string,

    _fiscali_ragione_sociale?: string,
    _fiscali_partita_iva?: string,
    _fiscali_codice_fiscale?: string,

    titolo_descrizione?: string,
    descrizione_descrizione?: string,

    _certificati_ultimo_titolo?: string,
    _certificati_primo_soccorso?: boolean,
    _certificati_bls?: boolean,
    _certificati_educatore?: boolean,
    _certificati_animatore?: boolean,
    _certificati_italiano?: boolean,
    _certificati_inglese?: boolean,
    _certificati_francese?: boolean,
    _certificati_spagnolo?: boolean,
    _certificati_tedesco?: boolean,
    _certificati_italiano_madrelingua?: boolean,
    _certificati_inglese_madrelingua?: boolean,
    _certificati_francese_madrelingua?: boolean,
    _certificati_spagnolo_madrelingua?: boolean,
    _certificati_tedesco_madrelingua?: boolean,
    _certificati_altre_lingue?: string,

    _formazione_lavoro_bambini?: string,
    _formazione_lavoro_asilo?: string,
    _formazione_esperienza_0m?: boolean,
    _formazione_esperienza_10m?: boolean,
    _formazione_esperienza_19m?: boolean,
    _formazione_esperienza_3a?: boolean,
    _formazione_esperienza_7a?: boolean,
    _formazione_esperienza_11a?: boolean,
    _formazione_ludico?: boolean,
    _formazione_movimento?: boolean,
    _formazione_lettura?: boolean,
    _formazione_truccabimbi?: boolean,
    _formazione_feste?: boolean,
    _formazione_caccia?: boolean,
    _formazione_corsi?: boolean,
    _formazione_massaggio?: boolean,
    _formazione_comunicazione?: boolean,
    _formazione_wedding?: boolean,
    _formazione_spiaggia?: boolean,
    _formazione_musica?: boolean,
    _formazione_compiti?: boolean,

    formazione_diploma?: string,
    formazione_universita?: any[],

    _materie_insegnate?: any[],

    _esperienze_lavorative?: any[],
    tmp_esperienza?: any,
    tmp_lingua?: any,
    tmp_competenza?: any,

    _altre_info_patente?: boolean,
    _altre_info_fumatore?: boolean,
    _altre_info_nuotare?: boolean,
    _altre_info_pulizie?: boolean,
    _altre_info_dog?: boolean,
    _altre_info_cucina_bambini?: boolean,
    _altre_info_cucina_italiana?: boolean,
    _altre_info_cucina_internazionale?: boolean,
    _altre_info_cucina_vegetariana?: boolean,
    _altre_info_cucina_vegana?: boolean,
    _altre_info_cucina_intolleranze?: boolean,

    _lavorare_prolungati?: boolean,
    _lavorare_occasionali?: boolean,
    _lavorare_part?: boolean,
    _lavorare_full?: boolean,
    _lavorare_vacanze?: boolean,
    _lavorare_famiglia?: boolean,
    _lavorare_pari?: boolean,

    _tariffa_mia?: number,

    _lingue_lingue?: any[],
    _lingue_competenze?: any[],
    _lingue_anni?: string,

    _lezioni_casa_tua?: boolean,
    _lezioni_casa_studente?: boolean,
    _lezioni_pubblico?: boolean,
    _lezioni_online?: boolean,
    _lezioni_skype?: string,
    _lezioni_indirizzo?: any,
    _lezioni_indirizzo_data?: any,
    _lezioni_google?: any,

    _tariffe_elementari?: number,
    _tariffe_medie?: number,
    _tariffe_superiori?: number,
    _tariffe_universita?: number,
    _tariffe_altre_tipologie?: number,
    
    __editing_image?: string,
    __uploaded?: boolean,
}

export default class ModuloRegistrazione extends React.Component<Props, State> {
    steps = [
        [1, 99],
        [1, /*17,*/ 99],
        [1, 11, 12, 6, 15, 14, 16, 99],
        [1, 7, 9, 10, 8, 2, 6, 99],
        [1, 19, 18, 99]
    ];

    constructor(props) {
        super(props);

        this.state = {
            index: 0,
            loading: false,
            step: this.steps[this.props.account-1][0],
            modal: false,
            tmodal: 0,
            province: [],
            user: null,
            province: shared.provincia,
        } as State;

        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.handleUploadLogo = this.handleUploadLogo.bind(this);
        this.getAccordionRow = this.getAccordionRow.bind(this);
        this.goToStep = this.goToStep.bind(this);
        this.scrollIt = this.scrollIt.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.deleteEsperienza = this.deleteEsperienza.bind(this);
    }

    componentDidMount() {

        this.getCountries((response) => {

            const countryValues = response.map((item) => {
                return {
                    key: item.cod,
                    value: item.name
                }
            });

            this.setState({
                countries: response,
                countryValues,
            });

            this.getSubjects((response) => {
                const subjectValues = response.map((item) => {
                    return {
                        key: item.id,
                        value: item.nome
                    }
                });

                this.setState({
                    subjects: response,
                    subjectValues,
                });

                this.getSkills((response) => {

                    const skillValues = response.map((item) => {
                        return {
                            key: item.id,
                            value: item.nome
                        }
                    });

                    this.setState({
                        skills: response,
                        skillValues,
                    });


                    this.getLanguages((response) => {

                        const languageValues = response.map((item) => {
                            return {
                                key: item.cod,
                                value: item.nome
                            }
                        });

                        this.setState({
                            languages: response,
                            languageValues,
                        });

                    });

                });
            });

            // console.log('user', user);
            this.getUser(user.id, (response) => {
                console.log('danilo', response);

                const elm = document.querySelector('.box-active-accordion');

                if(elm != null) {
                    this.scrollIt(elm, 500);
                }

                this.setState({
                    user: response,
                    nome: response.nome,
                    cognome: response.cognome,
                    data_nascita_gg: response.data_nascita ? response.data_nascita.substr(8,2) : '',
                    data_nascita_mm: response.data_nascita ? response.data_nascita.substr(5,2) : '',
                    data_nascita_yyyy: response.data_nascita ? response.data_nascita.substr(0,4) : '',
                    indirizzo: response.indirizzo,
                    comune: response.comune,
                    id_provincia: response.id_provincia,
                    cap: response.cap,
                    nazione: response.nazione || 'IT',
                    sesso: response.sesso,
                    telefono_pfx: response.telefono_pfx || '+39',
                    telefono_num: response.telefono_num,
                    foto: response.foto,
                    logo_url: response.logo_url,
                });

                if( response.extra !== null && response.hasOwnProperty('extra') && response.extra.hasOwnProperty('numero_figli') ) {
                    this.setState({ numero_figli: response.extra.numero_figli });
                } else {
                    this.setState({ numero_figli: 0 });
                }

                if( response.extra !== null && response.hasOwnProperty('extra') && response.extra.hasOwnProperty('figli') && response.extra.figli !== null ) {
                    this.setState({ figli: JSON.parse(response.extra.figli) });
                } else {
                    this.setState({ figli: null });
                }

                if( response.extra !== null && response.hasOwnProperty('extra') ) {

                    if( response.extra.hasOwnProperty('automunito')) {
                        console.log('test automunito', (response.extra.automunito === 1));

                        this.setState({
                            automunito: (response.extra.automunito == 1),
                            patente_b: (response.extra.patente_b == 1),
                        })
                    }

                    if( response.extra.hasOwnProperty('ultima_scuola') ) {
                        // no pre-selection
                        /*this.setState( {
                            scuola_frequentata: {
                                id: response.extra.ultima_scuola.id,
                                name: response.extra.ultima_scuola.nome,
                                isPubblico: response.extra.ultima_scuola.isPubblico,
                                isGestita: response.extra.ultima_scuola.isGestita,
                            }
                        } );*/
                    }

                    if( response.extra.hasOwnProperty('esperienze') && response.extra.esperienze !== null ) {
                        this.setState({ _esperienze_lavorative: JSON.parse(response.extra.esperienze) });
                    }

                    if( response.extra.hasOwnProperty('esperienza_insegnamento') && response.extra.esperienza_insegnamento !== null ) {
                        this.setState({ _lingue_anni: response.extra.esperienza_insegnamento });
                    }

                    if( response.extra.hasOwnProperty('titolo_descrizione') && response.extra.titolo_descrizione !== null ) {
                        this.setState({ titolo_descrizione: response.extra.titolo_descrizione });
                    }
                    if( response.extra.hasOwnProperty('descrizione_descrizione') && response.extra.descrizione_descrizione !== null ) {
                        this.setState({ descrizione_descrizione: response.extra.descrizione_descrizione });
                    }
                    if( response.extra.hasOwnProperty('diploma') && response.extra.diploma !== null ) {
                        this.setState({ formazione_diploma: response.extra.diploma });
                    }

                    if( response.extra.hasOwnProperty('lezione_casa_tua') && response.extra.lezione_casa_tua !== null ) {
                        this.setState({ _lezioni_casa_tua: response.extra.lezione_casa_tua });
                    }
                    if( response.extra.hasOwnProperty('lezione_casa_studente') && response.extra.lezione_casa_studente !== null ) {
                        this.setState({ _lezioni_casa_studente: response.extra.lezione_casa_studente });
                    }
                    if( response.extra.hasOwnProperty('lezione_pubblico') && response.extra.lezione_pubblico !== null ) {
                        this.setState({ _lezioni_pubblico: response.extra.lezione_pubblico });
                    }
                    if( response.extra.hasOwnProperty('lezione_online') && response.extra.lezione_online !== null ) {
                        this.setState({ _lezioni_online: response.extra.lezione_online });
                    }
                    if( response.extra.hasOwnProperty('indirizzo') && response.extra.indirizzo !== null ) {
                        this.setState({ _lezioni_indirizzo: response.extra.indirizzo });
                        //document.getElementsByClassName('geosuggest__input GeoAutocompleteControl-input')[0].value = document.getElementsByName('_lezioni_indirizzo')[0].value
                    }
                    if( response.extra.hasOwnProperty('indirizzo_data') && response.extra.indirizzo_data !== null ) {
                        this.setState({ _lezioni_indirizzo_data: response.extra.indirizzo_data });
                    }

                    if( response.extra.hasOwnProperty('Latitudine') && response.extra.Latitudine !== null ) {
                        this.setState({ _lezioni_google: {
                            name: response.extra.indirizzo,
                            lat: parseFloat(response.extra.Latitudine),
                            lng: parseFloat(response.extra.Longitudine),
                            zoom: 16,
                            center: {
                                lat: parseFloat(response.extra.Latitudine),
                                lng: parseFloat(response.extra.Longitudine),
                            }
                        } });
                    }

                    if( response.hasOwnProperty('skype') && response.skype !== null ) {
                        this.setState({ _lezioni_skype: response.skype });
                    }

                    if( response.extra.hasOwnProperty('formazione_universitaria') && response.extra.formazione_universitaria !== null ) {
                        const formazione_universitaria = response.extra.formazione_universitaria.map((item, index) => {
                            item.name = item.tipologia;
                            item.livello = item.titolo;
                            item.desc = item.titolo;
                            item.key = index;
                            return item;
                        });
                        this.setState({ formazione_universita: formazione_universitaria });
                    }

                    if( response.extra.hasOwnProperty('languages') && response.extra.languages !== null ) {
                        const languages = response.extra.languages.map((item, index) => {
                            item.key = index;
                            return item;
                        });
                        this.setState({ _lingue_lingue: languages });
                    }

                    if( response.extra.hasOwnProperty('competenze') && response.extra.competenze !== null ) {

                        const competenze = response.extra.competenze.map((item, index) => {
                            item.key = index;
                            return item;
                        });
                        this.setState({ _lingue_competenze: competenze });
                    }

                    if( response.extra.hasOwnProperty('materie') && response.extra.competenze !== null ) {

                        const materie = response.extra.materie.map((item, index) => {

                            let base = "(";
                            if(item.elementari)
                                base += ' Elementari ';
                            if(item.medie)
                                base += ' Medie ';
                            if(item.superiori)
                                base += ' Superiori ';
                            if(item.universita)
                                base += ' Università ';
                            if(item.extra)
                                base += ' Extra ';
                            base += ")";

                            item.name = item.nome;
                            item.materia = item.subject_id;
                            item.scuole = base;
                            item.key = index;
                            item.scuole_cond = {
                                elementari: (item.elementari) ? 1 : 0,
                                medie: (item.medie) ? 1 : 0,
                                superiori: (item.superiori) ? 1 : 0,
                                universita: (item.universita) ? 1 : 0,
                                extra: (item.extra) ? 1 : 0,
                            };

                            return item;
                        });
                        this.setState({ _materie_insegnate: materie });
                    }

                    if( response.extra.hasOwnProperty('patente') && response.extra.patente !== null ) {
                        this.setState({ _altre_info_patente: response.extra.patente });
                    }

                    if( response.extra.hasOwnProperty('fumatore') && response.extra.fumatore !== null ) {
                        this.setState({ _altre_info_fumatore: response.extra.fumatore });
                    }
                    if( response.extra.hasOwnProperty('nuotare') && response.extra.nuotare !== null ) {
                        this.setState({ _altre_info_nuotare: response.extra.nuotare });
                    }
                    if( response.extra.hasOwnProperty('pulizie') && response.extra.pulizie !== null ) {
                        this.setState({ _altre_info_pulizie: response.extra.pulizie });
                    }
                    if( response.extra.hasOwnProperty('cucina_bambini') && response.extra.cucina_bambini !== null ) {
                        this.setState({ _altre_info_cucina_bambini: response.extra.cucina_bambini });
                    }
                    if( response.extra.hasOwnProperty('cucina_italiana') && response.extra.cucina_italiana !== null ) {
                        this.setState({ _altre_info_cucina_italiana: response.extra.cucina_italiana });
                    }
                    if( response.extra.hasOwnProperty('cucina_internazionale') && response.extra.cucina_internazionale !== null ) {
                        this.setState({ _altre_info_cucina_internazionale: response.extra.cucina_internazionale });
                    }
                    if( response.extra.hasOwnProperty('cucina_vegetariana') && response.extra.cucina_vegetariana !== null ) {
                        this.setState({ _altre_info_cucina_vegetariana: response.extra.cucina_vegetariana });
                    }
                    if( response.extra.hasOwnProperty('cucina_vegana') && response.extra.cucina_vegana !== null ) {
                        this.setState({ _altre_info_cucina_vegana: response.extra.cucina_vegana });
                    }
                    if( response.extra.hasOwnProperty('cucina_intolleranze') && response.extra.cucina_intolleranze !== null ) {
                        this.setState({ _altre_info_cucina_intolleranze: response.extra.cucina_intolleranze });
                    }
                    if( response.extra.hasOwnProperty('dogsitter') && response.extra.dogsitter !== null ) {
                        this.setState({ _altre_info_dog: response.extra.dogsitter });
                    }
                    if( response.extra.hasOwnProperty('periodi_full_time') && response.extra.periodi_full_time !== null ) {
                        this.setState({ _lavorare_full: response.extra.periodi_full_time });
                    }
                    if( response.extra.hasOwnProperty('periodi_part_time') && response.extra.periodi_part_time !== null ) {
                        this.setState({ _lavorare_part: response.extra.periodi_part_time });
                    }
                    if( response.extra.hasOwnProperty('periodi_occasionali') && response.extra.periodi_occasionali !== null ) {
                        this.setState({ _lavorare_occasionali: response.extra.periodi_occasionali });
                    }
                    if( response.extra.hasOwnProperty('periodi_prolungati') && response.extra.periodi_prolungati !== null ) {
                        this.setState({ _lavorare_prolungati: response.extra.periodi_prolungati });
                    }
                    if( response.extra.hasOwnProperty('periodi_vacanze') && response.extra.periodi_vacanze !== null ) {
                        this.setState({ _lavorare_vacanze: response.extra.periodi_vacanze });
                    }
                    if( response.extra.hasOwnProperty('trasferire_famiglia') && response.extra.trasferire_famiglia !== null ) {
                        this.setState({ _lavorare_famiglia: response.extra.trasferire_famiglia });
                    }
                    if( response.extra.hasOwnProperty('trasferire_pari') && response.extra.trasferire_pari !== null ) {
                        this.setState({ _lavorare_pari: response.extra.trasferire_pari });
                    }
                    if( response.extra.hasOwnProperty('tariffa_oraria') && response.extra.tariffa_oraria !== null ) {
                        this.setState({ _tariffa_mia: response.extra.tariffa_oraria });
                    }
                    if( response.extra.hasOwnProperty('tariffa_elementari') && response.extra.tariffa_elementari !== null ) {
                        this.setState({ _tariffe_elementari: response.extra.tariffa_elementari });
                    }
                    if( response.extra.hasOwnProperty('tariffa_medie') && response.extra.tariffa_medie !== null ) {
                        this.setState({ _tariffe_medie: response.extra.tariffa_medie });
                    }
                    if( response.extra.hasOwnProperty('tariffa_superiori') && response.extra.tariffa_superiori !== null ) {
                        this.setState({ _tariffe_superiori: response.extra.tariffa_superiori });
                    }
                    if( response.extra.hasOwnProperty('tariffa_universita') && response.extra.tariffa_universita !== null ) {
                        this.setState({ _tariffe_universita: response.extra.tariffa_universita });
                    }
                    if( response.extra.hasOwnProperty('tariffa_altre_tipologie') && response.extra.tariffa_altre_tipologie !== null ) {
                        this.setState({ _tariffe_altre_tipologie: response.extra.tariffa_altre_tipologie });
                    }

                    if( response.extra.hasOwnProperty('ultimo_titolo_studio') && response.extra.ultimo_titolo_studio !== null ) {
                        this.setState({ _certificati_ultimo_titolo: response.extra.ultimo_titolo_studio });
                    }
                    if( response.extra.hasOwnProperty('certificato_bls') && response.extra.certificato_bls !== null ) {
                        this.setState({ _certificati_bls: response.extra.certificato_bls });
                    }
                    if( response.extra.hasOwnProperty('certificato_primo_soccorso') && response.extra.certificato_primo_soccorso !== null ) {
                        this.setState({ _certificati_primo_soccorso: response.extra.certificato_primo_soccorso });
                    }
                    if( response.extra.hasOwnProperty('certificato_educatore') && response.extra.certificato_educatore !== null ) {
                        this.setState({ _certificati_educatore: response.extra.certificato_educatore });
                    }
                    if( response.extra.hasOwnProperty('certificato_animatore') && response.extra.certificato_animatore !== null ) {
                        this.setState({ _certificati_animatore: response.extra.certificato_animatore });
                    }
                    if( response.extra.hasOwnProperty('italiano') && response.extra.italiano !== null ) {
                        this.setState({ _certificati_italiano: response.extra.italiano });
                    }
                    if( response.extra.hasOwnProperty('inglese') && response.extra.inglese !== null ) {
                        this.setState({ _certificati_inglese: response.extra.inglese });
                    }
                    if( response.extra.hasOwnProperty('francese') && response.extra.francese !== null ) {
                        this.setState({ _certificati_francese: response.extra.francese });
                    }
                    if( response.extra.hasOwnProperty('spagnolo') && response.extra.spagnolo !== null ) {
                        this.setState({ _certificati_spagnolo: response.extra.spagnolo });
                    }
                    if( response.extra.hasOwnProperty('tedesco') && response.extra.tedesco !== null ) {
                        this.setState({ _certificati_tedesco: response.extra.tedesco });
                    }

                    if( response.extra.hasOwnProperty('italiano_madrelingua') && response.extra.italiano_madrelingua !== null ) {
                        this.setState({ _certificati_italiano_madrelingua: response.extra.italiano_madrelingua });
                    }
                    if( response.extra.hasOwnProperty('inglese_madrelingua') && response.extra.inglese_madrelingua !== null ) {
                        this.setState({ _certificati_inglese_madrelingua: response.extra.inglese_madrelingua });
                    }
                    if( response.extra.hasOwnProperty('francese_madrelingua') && response.extra.francese_madrelingua !== null ) {
                        this.setState({ _certificati_francese_madrelingua: response.extra.francese_madrelingua });
                    }
                    if( response.extra.hasOwnProperty('spagnolo_madrelingua') && response.extra.spagnolo_madrelingua !== null ) {
                        this.setState({ _certificati_spagnolo_madrelingua: response.extra.spagnolo_madrelingua });
                    }
                    if( response.extra.hasOwnProperty('tedesco_madrelingua') && response.extra.tedesco_madrelingua !== null ) {
                        this.setState({ _certificati_tedesco_madrelingua: response.extra.tedesco_madrelingua });
                    }


                    if( response.extra.hasOwnProperty('altre_lingue') && response.extra.altre_lingue !== null ) {
                        this.setState({ _certificati_altre_lingue: response.extra.altre_lingue });
                    }
                    if( response.extra.hasOwnProperty('esperienza') && response.extra.esperienza !== null ) {
                        this.setState({ _formazione_lavoro_bambini: response.extra.esperienza });
                    }
                    if( response.extra.hasOwnProperty('esperienza_asilo') && response.extra.esperienza_asilo !== null ) {
                        this.setState({ _formazione_lavoro_asilo: (response.extra.esperienza_asilo == 1) ? 'si' : 'no' });
                    }
                    if( response.extra.hasOwnProperty('bambini_0m') && response.extra.bambini_0m !== null ) {
                        this.setState({ _formazione_esperienza_0m: response.extra.bambini_0m });
                    }
                    if( response.extra.hasOwnProperty('bambini_10m') && response.extra.bambini_10m !== null ) {
                        this.setState({ _formazione_esperienza_10m: response.extra.bambini_10m });
                    }
                    if( response.extra.hasOwnProperty('bambini_19m') && response.extra.bambini_19m !== null ) {
                        this.setState({ _formazione_esperienza_19m: response.extra.bambini_19m });
                    }
                    if( response.extra.hasOwnProperty('bambini_3a') && response.extra.bambini_3a !== null ) {
                        this.setState({ _formazione_esperienza_3a: response.extra.bambini_3a });
                    }
                    if( response.extra.hasOwnProperty('bambini_7a') && response.extra.bambini_7a !== null ) {
                        this.setState({ _formazione_esperienza_7a: response.extra.bambini_7a });
                    }
                    if( response.extra.hasOwnProperty('bambini_11a') && response.extra.bambini_11a !== null ) {
                        this.setState({ _formazione_esperienza_11a: response.extra.bambini_11a });
                    }
                    if( response.extra.hasOwnProperty('attivita_ludico') && response.extra.attivita_ludico !== null ) {
                        this.setState({ _formazione_ludico: response.extra.attivita_ludico });
                    }
                    if( response.extra.hasOwnProperty('attivita_giochi') && response.extra.attivita_giochi !== null ) {
                        this.setState({ _formazione_movimento: response.extra.attivita_giochi });
                    }
                    if( response.extra.hasOwnProperty('attivita_lettura') && response.extra.attivita_lettura !== null ) {
                        this.setState({ _formazione_lettura: response.extra.attivita_lettura });
                    }
                    if( response.extra.hasOwnProperty('attivita_trucca') && response.extra.attivita_trucca !== null ) {
                        this.setState({ _formazione_truccabimbi: response.extra.attivita_trucca });
                    }
                    if( response.extra.hasOwnProperty('attivita_feste') && response.extra.attivita_feste !== null ) {
                        this.setState({ _formazione_feste: response.extra.attivita_feste });
                    }
                    if( response.extra.hasOwnProperty('attivita_caccia') && response.extra.attivita_caccia !== null ) {
                        this.setState({ _formazione_caccia: response.extra.attivita_caccia });
                    }
                    if( response.extra.hasOwnProperty('attivita_corsi') && response.extra.attivita_corsi !== null ) {
                        this.setState({ _formazione_corsi: response.extra.attivita_corsi });
                    }
                    if( response.extra.hasOwnProperty('attivita_massaggio') && response.extra.attivita_massaggio !== null ) {
                        this.setState({ _formazione_massaggio: response.extra.attivita_massaggio });
                    }
                    if( response.extra.hasOwnProperty('attivita_comunicazione') && response.extra.attivita_comunicazione !== null ) {
                        this.setState({ _formazione_comunicazione: response.extra.attivita_comunicazione });
                    }
                    if( response.extra.hasOwnProperty('attivita_wedding') && response.extra.attivita_wedding !== null ) {
                        this.setState({ _formazione_wedding: response.extra.attivita_wedding });
                    }
                    if( response.extra.hasOwnProperty('attivita_spiaggia') && response.extra.attivita_spiaggia !== null ) {
                        this.setState({ _formazione_spiaggia: response.extra.attivita_spiaggia });
                    }
                    if( response.extra.hasOwnProperty('attivita_musica') && response.extra.attivita_musica !== null ) {
                        this.setState({ _formazione_musica: response.extra.attivita_musica });
                    }
                    if( response.extra.hasOwnProperty('attivita_compiti') && response.extra.attivita_compiti !== null ) {
                        this.setState({ _formazione_compiti: response.extra.attivita_compiti });
                    }

                } else {

                    this.setState({
                        automunito: false,
                        patente_b: false,
                    })

                }
            });

            // scroll to top

            setTimeout(() => {

                let hash = window.location.hash;
                if (hash) {
                    hash = parseInt(hash.substr(1));
                    this.goToStep(hash);
                    const elm = document.getElementById("profile-step-" + hash);
                    if(elm != null) {
                        setTimeout( () => {
                            this.scrollIt(elm, 500);
                        }, 100);
                    }
                } else {
                    console.log('scroll to top');
                    const elm = document.querySelector('.box-active-accordion');
                    console.log('elm', elm);
    
                    if(elm != null) {
                        this.scrollIt(elm, 500);
                    }
                }

            }, 1000);

        });

    }

    handleChange(field, value, child?) {

        console.log(field, value, child);

        if((field == "data_nascita_gg" || field == "data_nascita_mm" || field == "data_nascita_yyyy") && (value === 'undefined' || value === 'null')) {
            this.setState({
                [field]: 'null'
            });
            return;
        }

        if(field == "numero_figli") {
            console.log('state in numero_figli');
            let c_arr = new Array(parseInt(value));
            this.setState({
                figli: c_arr,
                [field]: parseInt(value)
            });

            return;
        } else if(field.indexOf("figli_") !== -1) {
            console.log('state in figli');
            const { figli } = this.state;
            figli[ field.substr(field.indexOf("_")+1) ] = parseInt(value);
            this.setState({
                figli,
            });

            return;
        }

        if(child !== undefined && this.state[field] !== undefined) {
            let arr = this.state[field];
            arr[child] = value;

            console.log(arr);

            this.setState({
                [field]: arr,
            });
        } else {
            this.setState({
                [field]: value
            });
        }
    }

    getCountries(callback) {
        api({
            method: "GET",
            url: `countries`,
        }).then((response) => {
            console.log('countries', response);
            callback(response);
        });
    }

    getUser(id, callback) {
        api({
            method: "GET",
            url: `users/${id}`,
        }).then((response) => {
            console.log('response', response);
            callback(response);
        });
    }

    getSubjects(callback) {
        api({
            method: "GET",
            url: `skills?id_tipologia=1`,
        }).then((response) => {
            console.log('response', response);
            callback(response);
        });
    }

    getLanguages(callback) {
        api({
            method: "GET",
            url: `languages`,
        }).then((response) => {
            console.log('language response', response);
            callback(response);
        });
    }

    getSkills(callback) {
        api({
            method: "GET",
            url: `skills?id_tipologia=2`,
        }).then((response) => {
            console.log('response', response);
            callback(response);
        });
    }

    handleUploadFile(endpoint, formName, file, callback) {

        const form = new FormData();
        form.append('file', file);
        // form.append('filename', formName);

        api({
            method: "POST",
            url: `users/${user.id}/${endpoint}`,
            data: form,
            contentType : false,
            processData : false
        }).then((response) => {
            console.log('response', response);

            callback(response);
        });
    }

    handleUploadLogo(ev) {
        ev.preventDefault();
        this.setState({
            showUploadButton: false,
            uploadInProgress: true
        });


        console.log('image', ev.target);

        const form = new FormData();
        form.append('logoUser', this.fileUploadBtn.files[0]);

        var reader = new FileReader();

        const _this = this;
        reader.onload = function (e) {
            // e.target.result;
        }

        reader.readAsDataURL(this.fileUploadBtn.files[0]);

        api({
            method: "POST",
            url: `users/${user.id}/update/picture`,
            data: form,
            contentType : false,
            processData : false
        }).then((response) => {
            const $url = response.path;
            _this.setState({
                logo_url: $url,
                __editing_image: $url,
                __uploaded: true
            })
            console.log('response', response);
        }).catch(e => {
            alert('Caricamento fallito')
        });
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validatePhone(phone) {
        var re = /^-?\d+\.?\d*$/;
        return re.test(String(phone).toLowerCase());
    }
    validateFigli(figli) {
        let errore = false;
        for(var i=0; i<figli.length; i++) {
            if(figli[i] < 1) {
                errore = true;
            }
        }

        return errore;
    }

    isGestore = () => (this.props.account === 5);
    isDocente = () => (this.props.account === 3);
    isTata = () => (this.props.account === 4);

    validateInput(account) {
        let isValid = true;

        console.log('state', this.state, this.props);
        
        switch(this.state.step) {
            case 1:
                    const {
                        nome,
                        cognome,
                        data_nascita_gg,
                        data_nascita_mm,
                        data_nascita_yyyy,
                        indirizzo,
                        comune,
                        id_provincia,
                        cap,
                        nazione,
                        sesso,
                        telefono_pfx,
                        telefono_num,
                        foto,
                        automunito,
                        patente_b,
                        numero_figli,
                        figli,
                    } = this.state;

                    if(nome === undefined || cognome === undefined || nome === "" || cognome === "" || nome === 'null' || cognome === 'null' || nome === null || cognome === null ) {
                        notify( { text: 'Compilare correttamente nome e cognome.', type: 'error' } );
                        isValid = false;
                    }

                    if( (account.nome != 'Genitore') && ( (data_nascita_gg === undefined || data_nascita_gg === 'null') || (data_nascita_mm === undefined || data_nascita_mm === 'null') || (data_nascita_yyyy === undefined || data_nascita_yyyy === 'null')) ) {
                        notify( { text: 'Compilare correttamente la data di nascita.', type: 'error' } );
                        isValid = false;
                    }
                    
                    if (!this.isGestore()) {
                        if (this.props.profilo) {
                            if((nazione === undefined || nazione === null || nazione === 'null')) {
                                notify( { text: 'Compilare correttamente la nazione.', type: 'error' } );
                                isValid = false;
                            }
                            if(indirizzo === undefined || indirizzo === "" || indirizzo === "null" || indirizzo === null ) {
                                notify( { text: 'Compilare correttamente l\'indirizzo.', type: 'error' } );
                                isValid = false;
                            }
                        }

                        if(id_provincia === undefined || id_provincia === "" || id_provincia === "null" || id_provincia === null) {
                            notify( { text: 'Compilare correttamente la provincia.', type: 'error' } );
                            isValid = false;
                        }
                        if(comune === undefined || comune === "" || comune === "null" || comune === null ) {
                            notify( { text: 'Compilare correttamente il comune.', type: 'error' } );
                            isValid = false;
                        }
                        if(cap === undefined || cap === "" || cap === "null" || cap === null ) {
                            notify( { text: 'Compilare correttamente il cap.', type: 'error' } );
                            isValid = false;
                        }
                    }
                    
                    if (account.nome !== 'Genitore' && account.nome !== 'Studente') {
                        if(telefono_num === undefined || telefono_num === "" || telefono_num === "null" || ! this.validatePhone(telefono_num)) {
                            notify( { text: 'Formato numero di telefono non valido, inserire solo numeri.', type: 'error' } );
                            isValid = false;
                        }
                        if(telefono_pfx === undefined || telefono_num === undefined || telefono_pfx === "" || telefono_num === "" || telefono_pfx === "null" || telefono_num === "null") {
                            notify( { text: 'Compilare correttamente prefisso e numero di telefono.', type: 'error' } );
                            isValid = false;
                        }
                    }

                    if((numero_figli === undefined || numero_figli === "") && account.nome === 'Genitore' ) {
                        notify( { text: 'Compilare correttamente il numeri di figli.', type: 'error' } );
                        isValid = false;
                    } else {
                        if((account.nome == 'Genitore') && (figli !== undefined && figli && figli.length > 0) && (Object.keys(figli).length !== parseInt(numero_figli) || figli.filter(function(i){ return isNaN(i); }).length > 0) ) {
                            notify( { text: 'Compilare correttamente le età di tutti i figli.', type: 'error' } );
                            isValid = false;
                        }
                        if( (account.nome == 'Genitore') && figli !== undefined && figli && figli.length > 0 && this.validateFigli(figli) ) {
                            notify( { text: 'Le età di tutti i figli devono essere positive.', type: 'error' } );
                            isValid = false;
                        }
                    }


                    break;
            case 6:
                    /*
                    const {
                        titolo_descrizione,
                        descrizione_descrizione,
                    } = this.state;

                    if(titolo_descrizione === undefined || titolo_descrizione === '' || descrizione_descrizione === undefined || descrizione_descrizione === '' ) {
                        notify( { text: 'Compilare correttamente titolo e descrizione.', type: 'error' } );
                        isValid = false;
                    }

                    if( descrizione_descrizione !== undefined && descrizione_descrizione.length < 100 ) {
                        notify( { text: 'Inserire almeno 100 caratteri in descrizione.', type: 'error' } );
                        isValid = false;
                    }
                    */
                    break;
            case 7:
                    const {
                        _formazione_lavoro_bambini,
                        _formazione_lavoro_asilo,
                        _formazione_esperienza_0m,
                        _formazione_esperienza_10m,
                        _formazione_esperienza_19m,
                        _formazione_esperienza_3a,
                        _formazione_esperienza_7a,
                        _formazione_esperienza_11a,
                        _formazione_ludico,
                        _formazione_movimento,
                        _formazione_lettura,
                        _formazione_truccabimbi,
                        _formazione_feste,
                        _formazione_caccia,
                        _formazione_corsi,
                        _formazione_massaggio,
                        _formazione_comunicazione,
                        _formazione_wedding,
                        _formazione_spiaggia,
                        _formazione_musica,
                        _formazione_compiti,
                    } = this.state;

                    // todo: validation

                    if(_formazione_lavoro_bambini === undefined  ) {
                        notify( { text: 'Compilare correttamente anni di esperienza coi bambini.', type: 'error' } );
                        isValid = false;
                    } else if( _formazione_lavoro_asilo === undefined ) {
                        notify( { text: 'Indicare esperienza in asilo.', type: 'error' } );
                        isValid = false;
                    }

                    break;
            case 8:
                    const {
                        _altre_info_patente,
                        _altre_info_fumatore,
                        _altre_info_nuotare,
                        _altre_info_pulizie,
                        _altre_info_dog,
                        _altre_info_cucina_bambini,
                        _altre_info_cucina_italiana,
                        _altre_info_cucina_internazionale,
                        _altre_info_cucina_vegetariana,
                        _altre_info_cucina_vegana,
                        _altre_info_cucina_intolleranze,
                    } = this.state;

                    // todo: validation


                    break;
            case 9:
                    const {
                        _lavorare_prolungati,
                        _lavorare_occasionali,
                        _lavorare_part,
                        _lavorare_full,
                        _lavorare_vacanze,
                        _lavorare_famiglia,
                        _lavorare_pari,
                        _lezioni_indirizzo: ind
                    } = this.state;

                    if(ind === undefined || ind.length === 0) {
                        notify( { text: 'Inserire correttamente il tuo indirizzo.', type: 'error' } );
                        isValid = false;
                    }

                    break;
            case 10:
                    const {
                        _tariffa_mia
                    } = this.state;

                    if(_tariffa_mia === undefined) {
                        notify( { text: 'Inserire correttamente la tariffa.', type: 'error' } );
                        isValid = false;
                    }
                    if(_tariffa_mia <= 0) {
                        notify( { text: 'Inserire un valore positivo per la tariffa.', type: 'error' } );
                        isValid = false;
                    }
                    break;
            case 2:
                    const {
                        _certificati_ultimo_titolo
                    } = this.state;


                    if(_certificati_ultimo_titolo === undefined) {
                        notify( { text: 'Inserire correttamente ultimo titolo di studio.', type: 'error' } );
                        isValid = false;
                    }

                    break;
            case 11:
                    const { _materie_insegnate } = this.state;

                    if(_materie_insegnate === undefined || _materie_insegnate.length === 0) {
                        notify( { text: 'Inserire correttamente almeno una materia.', type: 'error' } );
                        isValid = false;
                    }

                    const {
                        _tariffe_elementari,
                        _tariffe_medie,
                        _tariffe_superiori,
                        _tariffe_universita,
                        _tariffe_altre_tipologie,
                    } = this.state;

                    if(_tariffe_elementari !== undefined && _tariffe_elementari !== '' && _tariffe_elementari < 0) {
                        notify( { text: 'Inserire correttamente tariffa oraria elementari.', type: 'error' } );
                        isValid = false;
                    }
                    if(_tariffe_medie !== undefined && _tariffe_medie !== '' && _tariffe_medie < 0) {
                        notify( { text: 'Inserire correttamente tariffa oraria medie.', type: 'error' } );
                        isValid = false;
                    }
                    if(_tariffe_superiori !== undefined && _tariffe_superiori !== '' && _tariffe_superiori < 0) {
                        notify( { text: 'Inserire correttamente tariffa oraria superiori.', type: 'error' } );
                        isValid = false;
                    }
                    if(_tariffe_universita !== undefined && _tariffe_universita !== '' && _tariffe_universita < 0) {
                        notify( { text: 'Inserire correttamente tariffa oraria università.', type: 'error' } );
                        isValid = false;
                    }
                    if(_tariffe_altre_tipologie !== undefined && _tariffe_altre_tipologie !== ''&& _tariffe_altre_tipologie < 0) {
                        notify( { text: 'Inserire correttamente tariffa oraria altre tipologie.', type: 'error' } );
                        isValid = false;
                    }

                    break;
            case 12:
                    const { _lezioni_indirizzo } = this.state;

                    if(_lezioni_indirizzo === undefined || _lezioni_indirizzo.length === 0) {
                        notify( { text: 'Inserire correttamente il tuo indirizzo.', type: 'error' } );
                        isValid = false;
                    }
                    
                    break;
            case 14:

                    const {
                        _lingue_lingue,
                        _lingue_competenze,
                        _lingue_anni,
                    } = this.state;

                    if(_lingue_anni === undefined || _lingue_anni === '' || _lingue_anni === 'null') {
                        notify( { text: 'Inserire correttamente esperienza di insegnamento.', type: 'error' } );
                        isValid = false;
                    }

                    break;
            case 15:
                    const {
                        formazione_diploma,
                        formazione_universita,
                        scuola_frequentata,
                    } = this.state;

                    if(formazione_diploma === undefined || formazione_diploma === '') {
                        notify( { text: 'Inserire correttamente indicazione diploma.', type: 'error' } );
                        isValid = false;
                    }

                    // if(formazione_universita === undefined || formazione_universita === '') {
                    //     notify( { text: 'Inserire correttamente formazione universitaria.', type: 'error' } );
                    //     isValid = false;
                    // }

                    // if(scuola_frequentata === undefined || scuola_frequentata === '' || scuola_frequentata === null) {
                    //     notify( { text: 'Inserire correttamente scuola.', type: 'error' } );
                    //     isValid = false;
                    // }

                    break;
            case 16:
                    break;
            case 17:
                    const {
                        scuola_frequentata
                    } = this.state;


                    console.log('scuola_frequentata', scuola_frequentata);
                    /* no more required
                    if(scuola_frequentata === undefined || scuola_frequentata === null) {
                        alert('Selezionare correttamente una scuola.');
                        isValid = false;
                        break;
                    }
                    */

                    break;
            case 18:
                    const {
                        scuola_frequentata,
                        _animatore_nome,
                        _animatore_cognome,
                        _animatore_email,
                        _animatore_telefono,
                        _animatore_note,
                        _preside_nome,
                        _preside_cognome,
                        _preside_email,
                        _preside_telefono,
                        _preside_note,
                        _segreteria_nome,
                        _segreteria_cognome,
                        _segreteria_email,
                        _segreteria_telefono,
                        _segreteria_note,
                        _fiscali_ragione_sociale,
                        _fiscali_partita_iva,
                        _fiscali_codice_fiscale,
                    } = this.state;


                    if(scuola_frequentata === undefined || scuola_frequentata === null) {
                        notify( { text: 'Errore, scuola non selezionata.', type: 'error' } );
                        isValid = false;
                        break;
                    }

                    if(_animatore_nome === undefined) {
                        notify( { text: 'Inserire correttamente nome animatore.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_animatore_cognome === undefined) {
                        notify( { text: 'Inserire correttamente cognome animatore.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_animatore_email === undefined || ! this.validateEmail(_animatore_email)) {
                        notify( { text: 'Inserire correttamente email animatore.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_animatore_telefono === undefined) {
                        notify( { text: 'Inserire correttamente telefono animatore.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    // if(_animatore_note === undefined) {
                    //     alert('Inserire correttamente note animatore.');
                    //     isValid = false;
                    //     return;
                    // }
                    if(_preside_nome === undefined) {
                        notify( { text: 'Inserire correttamente cognome preside.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_preside_cognome === undefined) {
                        notify( { text: 'Inserire correttamente cognome preside.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_preside_email === undefined || ! this.validateEmail(_preside_email)) {
                        notify( { text: 'Inserire correttamente email preside.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_preside_telefono === undefined) {
                        notify( { text: 'Inserire correttamente telefono preside.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    // if(_preside_note === undefined) {
                    //     alert('Inserire correttamente note preside.');
                    //     isValid = false;
                    //     return;
                    // }
                    if(_segreteria_nome === undefined) {
                        notify( { text: 'Inserire correttamente nome segreteria.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_segreteria_cognome === undefined) {
                        notify( { text: 'Inserire correttamente cognome segreteria.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_segreteria_email === undefined || ! this.validateEmail(_segreteria_email)) {
                        notify( { text: 'Inserire correttamente email segreteria.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(_segreteria_telefono === undefined) {
                        notify( { text: 'Inserire correttamente telefono segreteria.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    // if(_segreteria_note === undefined) {
                    //     alert('Inserire correttamente note segreteria.');
                    //     isValid = false;
                    //     return;
                    // }

                    if(scuola_frequentata.isPubblico === false && (_fiscali_ragione_sociale === undefined || _fiscali_ragione_sociale === '')) {
                        notify( { text: 'Inserire correttamente ragione sociale della sede.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(scuola_frequentata.isPubblico === false && (_fiscali_partita_iva === undefined || _fiscali_partita_iva === '')) {
                        notify( { text: 'Inserire correttamente partita iva della sede.', type: 'error' } );
                        isValid = false;
                        return;
                    }
                    if(scuola_frequentata.isPubblico === false && (_fiscali_codice_fiscale === undefined || _fiscali_codice_fiscale === '')) {
                        notify( { text: 'Inserire correttamente codice fiscale della sede.', type: 'error' } );
                        isValid = false;
                        return;
                    }

                    break;


            case 19:
                const {
                    scuola_frequentata
                } = this.state;


                console.log('scuola_frequentata', scuola_frequentata);
                // if(scuola_frequentata === undefined || scuola_frequentata === null) {
                //     notify( { text: 'Selezionare correttamente una scuola.', type: 'error' } );
                //     isValid = false;
                //     break;
                // }

                break;
        }

        return isValid;
    }

    submit(id, callback) {

        const reference = [
            {
                id_categoria: null,
                nome: "Genitore",
                ruolo: "Privato"
            },
            {
                id_categoria: null,
                nome: "Studente",
                ruolo: "Privato"
            },
            {
                id_categoria: 2,
                nome: "Insegnante",
                ruolo: "Professionale"
            },
            {
                id_categoria: 5,
                nome: "Tata",
                ruolo: "Professionale"
            },
            {
                id_categoria: 1,
                nome: "Gestore di scuole",
                ruolo: "Professionale"
            }
        ];

        const account = reference[this.props.account-1];

        const onErr = () => {
            this.setState({
                isRequestLoading: false,
            });
        }

        if(! this.validateInput(account)) {
            onErr();
            return;
        }

        switch(this.state.step) {
            case 1:
                    const {
                        nome,
                        cognome,
                        data_nascita_gg,
                        data_nascita_mm,
                        data_nascita_yyyy,
                        indirizzo,
                        comune,
                        id_provincia,
                        cap,
                        nazione,
                        sesso,
                        telefono_pfx,
                        telefono_num,
                        foto,
                        automunito,
                        patente_b,
                        numero_figli,
                        figli,
                    } = this.state;

                    console.log('this.state', this.state);

                    api({
                        method: "POST",
                        url: `users/${id}/update/infos`,
                        data: {
                            account,
                            nome: (nome === undefined || nome === null) ? this.state.user.nome : nome,
                            cognome: (cognome === undefined || cognome === null) ? this.state.user.cognome : cognome,
                            data_nascita: (data_nascita_yyyy === undefined || data_nascita_mm === undefined || data_nascita_gg === undefined) ? this.state.user.data_nascita : `${data_nascita_yyyy}-${data_nascita_mm}-${data_nascita_gg}`,
                            indirizzo: (indirizzo === undefined || indirizzo === null) ? this.state.user.indirizzo : indirizzo,
                            comune: (comune === undefined || comune === null) ? this.state.user.comune : comune,
                            id_provincia: (id_provincia === undefined || id_provincia === null) ? this.state.user.id_provincia : id_provincia,
                            cap: (cap === undefined || cap === null) ? this.state.user.cap : cap,
                            nazione: (nazione === undefined || nazione === null) ? this.state.user.nazione : nazione,
                            sesso: (sesso === undefined || sesso === null) ? this.state.user.sesso : sesso,
                            telefono_pfx: (telefono_pfx === undefined || telefono_pfx === null) ? this.state.user.telefono_pfx : telefono_pfx,
                            telefono_num: (telefono_num === undefined || telefono_num === null) ? this.state.user.telefono_num : telefono_num,
                            foto: (foto === undefined || foto === null) ? this.state.user.foto : foto,
                            automunito: (automunito === undefined || automunito === null) ? this.state.user.automunito : automunito,
                            patente_b: (patente_b === undefined || patente_b === null) ? this.state.user.patente_b : patente_b,
                            numero_figli: (numero_figli === undefined || numero_figli === null) ? this.state.user.numero_figli : numero_figli,
                            figli: (figli === undefined || figli === null) ? this.state.user.figli : figli,
                            sono_un_genitore: (account.nome === 'Genitore')
                        }
                    }).then((response) => {
                        console.log('response', response);

                        callback(response);
                    }).catch((response) => {
                        // prevent error in console
                        console.log('error', response);
                        alert( {
                            text: response,
                            type: 'error'
                        } );
                        onErr();
                    })
                    ;
                    break;
            case 6:
                const {
                    titolo_descrizione,
                    descrizione_descrizione,
                } = this.state;

                console.log('this.state', this.state);

                api({
                    method: "POST",
                    url: `users/${id}/update/descriptions`,
                    data: {
                        account,
                        titolo_descrizione: (titolo_descrizione === undefined || titolo_descrizione === null) ? '' : titolo_descrizione,
                        descrizione_descrizione: (descrizione_descrizione === undefined || descrizione_descrizione === null) ? '' : descrizione_descrizione,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 7:
                console.log('this.state', this.state);

                const {
                    _formazione_lavoro_bambini,
                    _formazione_lavoro_asilo,
                    _formazione_esperienza_0m,
                    _formazione_esperienza_10m,
                    _formazione_esperienza_19m,
                    _formazione_esperienza_3a,
                    _formazione_esperienza_7a,
                    _formazione_esperienza_11a,
                    _formazione_ludico,
                    _formazione_movimento,
                    _formazione_lettura,
                    _formazione_truccabimbi,
                    _formazione_feste,
                    _formazione_caccia,
                    _formazione_corsi,
                    _formazione_massaggio,
                    _formazione_comunicazione,
                    _formazione_wedding,
                    _formazione_spiaggia,
                    _formazione_musica,
                    _formazione_compiti,
                } = this.state;


                api({
                    method: "POST",
                    url: `users/${id}/update/minicv`,
                    data: {
                        account,
                        esperienza: _formazione_lavoro_bambini,
                        esperienza_asilo: _formazione_lavoro_asilo,
                        bambini_0m: _formazione_esperienza_0m,
                        bambini_10m: _formazione_esperienza_10m,
                        bambini_19m: _formazione_esperienza_19m,
                        bambini_3a: _formazione_esperienza_3a,
                        bambini_7a: _formazione_esperienza_7a,
                        bambini_11a: _formazione_esperienza_11a,
                        attivita_ludico: _formazione_ludico,
                        attivita_giochi: _formazione_movimento,
                        attivita_lettura: _formazione_lettura,
                        attivita_trucca: _formazione_truccabimbi,
                        attivita_feste: _formazione_feste,
                        attivita_caccia: _formazione_caccia,
                        attivita_corsi: _formazione_corsi,
                        attivita_massaggio: _formazione_massaggio,
                        attivita_comunicazione: _formazione_comunicazione,
                        attivita_wedding: _formazione_wedding,
                        attivita_spiaggia: _formazione_spiaggia,
                        attivita_musica: _formazione_musica,
                        attivita_compiti: _formazione_compiti,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 8:
                console.log('this.state', this.state);

                const {
                    _altre_info_patente,
                    _altre_info_fumatore,
                    _altre_info_nuotare,
                    _altre_info_pulizie,
                    _altre_info_dog,
                    _altre_info_cucina_bambini,
                    _altre_info_cucina_italiana,
                    _altre_info_cucina_internazionale,
                    _altre_info_cucina_vegetariana,
                    _altre_info_cucina_vegana,
                    _altre_info_cucina_intolleranze,
                } = this.state;


                api({
                    method: "POST",
                    url: `users/${id}/update/other-infos`,
                    data: {
                        account,
                        patente: _altre_info_patente,
                        fumatore: _altre_info_fumatore,
                        nuotare: _altre_info_nuotare,
                        pulizie: _altre_info_pulizie,
                        dogsitter: _altre_info_dog,
                        cucina_bambini: _altre_info_cucina_bambini,
                        cucina_italiana: _altre_info_cucina_italiana,
                        cucina_internazionale: _altre_info_cucina_internazionale,
                        cucina_vegetariana: _altre_info_cucina_vegetariana,
                        cucina_vegana: _altre_info_cucina_vegana,
                        cucina_intolleranze: _altre_info_cucina_intolleranze,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 9:
                console.log('this.state', this.state);

                const {
                    _lavorare_prolungati,
                    _lavorare_occasionali,
                    _lavorare_part,
                    _lavorare_full,
                    _lavorare_vacanze,
                    _lavorare_famiglia,
                    _lavorare_pari,
                    _lezioni_indirizzo,
                    _lezioni_indirizzo_data,
                    _lezioni_google
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/availability`,
                    data: {
                        account,
                        periodi_prolungati: _lavorare_prolungati,
                        periodi_occasionali: _lavorare_occasionali,
                        periodi_part_time: _lavorare_part,
                        periodi_full_time: _lavorare_full,
                        periodi_vacanze: _lavorare_vacanze,
                        trasferire_famiglia: _lavorare_famiglia,
                        trasferire_pari: _lavorare_pari,
                        lezione_indirizzo: _lezioni_indirizzo,
                        lezione_indirizzo_data: _lezioni_indirizzo_data,
                        lezione_indirizzo_lat: (_lezioni_google !== undefined && _lezioni_google.hasOwnProperty('lat')) ? _lezioni_google.lat : null,
                        lezione_indirizzo_lng: (_lezioni_google !== undefined && _lezioni_google.hasOwnProperty('lng')) ? _lezioni_google.lng : null,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 10:
                console.log('this.state', this.state);

                const {
                    _tariffa_mia
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/single-rate`,
                    data: {
                        account,
                        tariffa_oraria: _tariffa_mia
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 2:

                console.log('this.state', this.state);


                const {
                    _certificati_ultimo_titolo,
                    _certificati_primo_soccorso,
                    _certificati_bls,
                    _certificati_educatore,
                    _certificati_animatore,
                    _certificati_italiano,
                    _certificati_inglese,
                    _certificati_francese,
                    _certificati_spagnolo,
                    _certificati_tedesco,
                    _certificati_italiano_madrelingua,
                    _certificati_inglese_madrelingua,
                    _certificati_francese_madrelingua,
                    _certificati_spagnolo_madrelingua,
                    _certificati_tedesco_madrelingua,
                    _certificati_altre_lingue,
                } = this.state;


                api({
                    method: "POST",
                    url: `users/${id}/update/formation`,
                    data: {
                        account,
                        ultimo_titolo_studio: _certificati_ultimo_titolo,
                        certificato_primo_soccorso: _certificati_primo_soccorso,
                        certificato_bls: _certificati_bls,
                        certificato_educatore: _certificati_educatore,
                        certificato_animatore: _certificati_animatore,
                        italiano: _certificati_italiano,
                        inglese: _certificati_inglese,
                        francese: _certificati_francese,
                        spagnolo: _certificati_spagnolo,
                        tedesco: _certificati_tedesco,
                        italiano_madrelingua: _certificati_italiano_madrelingua,
                        inglese_madrelingua: _certificati_inglese_madrelingua,
                        francese_madrelingua: _certificati_francese_madrelingua,
                        spagnolo_madrelingua: _certificati_spagnolo_madrelingua,
                        tedesco_madrelingua: _certificati_tedesco_madrelingua,
                        altre_lingue: _certificati_altre_lingue,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 11:
                console.log('this.state', this.state);

                const {
                    _materie_insegnate
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/subjects`,
                    data: {
                        account,
                        subjects: _materie_insegnate,
                    }
                }).then((response) => {
                    console.log('response', response);

                    const {
                        _tariffe_elementari,
                        _tariffe_medie,
                        _tariffe_superiori,
                        _tariffe_universita,
                        _tariffe_altre_tipologie,
                    } = this.state;

                    api({
                        method: "POST",
                        url: `users/${id}/update/rates`,
                        data: {
                            account,
                            tariffa_elementari: _tariffe_elementari,
                            tariffa_medie: _tariffe_medie,
                            tariffa_superiori: _tariffe_superiori,
                            tariffa_universita: _tariffe_universita,
                            tariffa_altre_tipologie: _tariffe_altre_tipologie,
                        }
                    }).then((response) => {
                        console.log('response', response);

                        callback(response);

                    });

                });
                break;
            case 12:

                console.log('this.state', this.state);

                const {
                    _lezioni_casa_tua,
                    _lezioni_casa_studente,
                    _lezioni_pubblico,
                    _lezioni_online,
                    _lezioni_skype,
                    _lezioni_indirizzo,
                    _lezioni_indirizzo_data,
                    _lezioni_google
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/private-lessons`,
                    data: {
                        account,
                        lezione_casa_tua: _lezioni_casa_tua,
                        lezione_casa_studente: _lezioni_casa_studente,
                        lezione_pubblico: _lezioni_pubblico,
                        lezione_online: _lezioni_online,
                        lezione_skype: _lezioni_skype,
                        lezione_indirizzo: _lezioni_indirizzo,
                        lezione_indirizzo_data: _lezioni_indirizzo_data,
                        lezione_indirizzo_lat: (_lezioni_google !== undefined && _lezioni_google.hasOwnProperty('lat')) ? _lezioni_google.lat : null,
                        lezione_indirizzo_lng: (_lezioni_google !== undefined && _lezioni_google.hasOwnProperty('lng')) ? _lezioni_google.lng : null,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 14:
                console.log('this.state', this.state);

                const {
                    _lingue_lingue,
                    _lingue_competenze,
                    _lingue_anni,
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/languages`,
                    data: {
                        account,
                        languages: _lingue_lingue,
                        skills: _lingue_competenze,
                        experiences: _lingue_anni,
                    }
                }).then((response) => {
                    console.log('response', response);


                    const competenze = response.updatedSkills.map((item, index) => {
                        item.key = index;
                        return item;
                    });

                    console.log('_lingue_competenze', competenze);

                    competenze.map((competenza) => {

                        console.log('competenza da server', competenza);
                        const { _lingue_competenze } = this.state;

                        const local = _lingue_competenze.filter((item) => item.competenza == parseInt(competenza.competenza) && item.titolo == competenza.titolo);

                        console.log('local', local);

                        if(local.length > 0 && local[0].file != null) {
                            this.handleUploadFile(
                                `upload/skills/${competenza.id}/file`,
                                local[0].filename,
                                local[0].file,
                                (response) => {
                                    console.log('post upload', response);
                                }
                            );
                        }

                    });


                    const languages = response.updatedLanguages.map((item, index) => {
                        item.key = index;
                        return item;
                    });

                    console.log('_lingue_lingue', languages);

                    languages.map((language) => {

                        console.log('lingua da server', language);
                        const { _lingue_lingue } = this.state;

                        const local = _lingue_lingue.filter((item) => item.nome == parseInt(language.nome) && item.titolo == language.titolo);

                        console.log('local', local);

                        if(local.length > 0 && local[0].file != null) {
                            this.handleUploadFile(
                                `upload/skills/${language.id}/file`,
                                local[0].filename,
                                local[0].file,
                                (response) => {
                                    console.log('post upload', response);
                                }
                            );
                        }

                    });

                    callback(response);

                });
                break;
            case 15:
                console.log('this.state', this.state);

                const {
                    formazione_diploma,
                    formazione_universita,
                    scuola_frequentata,
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/formation-p`,
                    data: {
                        account,
                        formazione_diploma,
                        formazione_universita,
                        scuola_frequentata: (scuola_frequentata !== null && scuola_frequentata !== undefined) ?
                            {
                                id: scuola_frequentata['id'],
                                nome: scuola_frequentata['name']
                            }
                        : null,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 16:
                console.log('this.state', this.state);

                api({
                    method: "POST",
                    url: `users/${id}/update/experiences`,
                    data: {
                        account,
                        esperienze: this.state._esperienze_lavorative

                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 17:
                console.log('this.state', this.state);

                const { scuola_frequentata } = this.state;

                console.log('test', scuola_frequentata);

                // as it's not mandatory, bypass if not set
                if (!scuola_frequentata) {
                    callback(response);
                } else {
                    api({
                        method: "POST",
                        url: `users/${id}/update/last-school`,
                        data: {
                            account,
                            scuola_frequentata: {
                                id: (scuola_frequentata && scuola_frequentata !== null && scuola_frequentata.hasOwnProperty('id')) ? scuola_frequentata['id'] : null,
                                nome: (scuola_frequentata && scuola_frequentata !== null && scuola_frequentata.hasOwnProperty('name')) ? scuola_frequentata['name'] : '',
                            },
                        }
                    }).then((response) => {
                        console.log('response', response);

                        callback(response);

                    });
                }
                break;
            case 18:
                console.log('this.state', this.state);

                const {
                    _animatore_nome,
                    _animatore_cognome,
                    _animatore_email,
                    _animatore_telefono,
                    _animatore_note,
                    _preside_nome,
                    _preside_cognome,
                    _preside_email,
                    _preside_telefono,
                    _preside_note,
                    _segreteria_nome,
                    _segreteria_cognome,
                    _segreteria_email,
                    _segreteria_telefono,
                    _segreteria_note,
                    _fiscali_ragione_sociale,
                    _fiscali_partita_iva,
                    _fiscali_codice_fiscale,
                } = this.state;

                api({
                    method: "POST",
                    url: `users/${id}/update/manage-school-request`,
                    data: {
                        account,
                        animatore_nome: _animatore_nome,
                        animatore_cognome: _animatore_cognome,
                        animatore_email: _animatore_email,
                        animatore_telefono: _animatore_telefono,
                        animatore_note: _animatore_note,
                        preside_nome: _preside_nome,
                        preside_cognome: _preside_cognome,
                        preside_email: _preside_email,
                        preside_telefono: _preside_telefono,
                        preside_note: _preside_note,
                        segreteria_nome: _segreteria_nome,
                        segreteria_cognome: _segreteria_cognome,
                        segreteria_email: _segreteria_email,
                        segreteria_telefono: _segreteria_telefono,
                        segreteria_note: _segreteria_note,
                        fiscali_ragione_sociale: _fiscali_ragione_sociale,
                        fiscali_partita_iva: _fiscali_partita_iva,
                        fiscali_codice_fiscale: _fiscali_codice_fiscale,
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                });
                break;
            case 19:
                console.log('this.state', this.state);

                const { scuola_frequentata } = this.state;

                console.log('test', scuola_frequentata);

                if (!scuola_frequentata) {
                    alert({text: `Richiedi la gestione della tua scuola o creane una nuova.`});
                    onErr();
                    return;
                }

                api({
                    method: "POST",
                    url: `users/${id}/update/last-school`,
                    data: {
                        account,
                        scuola_frequentata: {
                            id: (scuola_frequentata !== null && scuola_frequentata.hasOwnProperty('id')) ? scuola_frequentata['id'] : null,
                            nome: (scuola_frequentata !== null && scuola_frequentata.hasOwnProperty('name')) ? scuola_frequentata['name'] : '',
                        },
                    }
                }).then((response) => {
                    console.log('response', response);

                    callback(response);

                }).catch((response) => {
                    // prevent error in console
                    console.log('error', response);
                    alert( {
                        title: 'Richiesta di gestione',
                        text: `La scuola/sede è già gestita da un utente.<br />Se ritieni che l'attuale gestione non sia legittima ti preghiamo di contattarci scrivendo a <a href="mailto:info@schoolvisor.it">info@schoolvisor.it</a> o chiamando il numero: 3791727559`,
                        type: 'error'
                    } );
                    onErr();
                });
                break;
        }


    }


     goToStep(step) {

        const { user } = this.state;

        if(user && user.completato == 0) {
            return;
        }

        this.setState({
            step: step,
            index: (this.steps[this.props.account-1].indexOf(step)),
        });

        setTimeout(() => {
            console.log('next step & index', this.state.step, this.state.index);
        }, 2000);
    }

    nextStep() {
        if(this.state.index == (this.steps[this.props.account-1].length-1))
            return;
        if (this.state.isRequestLoading) {
            return;
        }

        console.log('click next');

        this.setState({
            isRequestLoading: true,
        });

        this.submit(user.id, (opts = {}) => {
            const step = this.steps[this.props.account-1][this.state.index+1];
            const index = this.state.index+1;
            console.log(step, index)

            this.setState({
                step,
                index,
                isRequestLoading: false,
            });

            if(step === 99) {

                const { user } = this.state;

                if(user && user.completato == 0) {
                    const elm = document.querySelector('.modulo_Registrazione');

                    if(elm != null) {
                        this.scrollIt(elm, 500);
                    }

                } else {
                    document.location.href = '/profile/index';
                }
            } else {
                const elm = document.querySelector('.box-active-accordion');

                if(elm != null) {
                    this.scrollIt(elm, 500);
                }

            }

            if (opts.notifyCompleted) {
                alert( {
                    text: 'Complimenti il tuo profilo ora è pubblico.',
                    type: 'success'
                } );
            }
        })
    }

    backStep() {
        if(this.state.index == 0) {
            this.props.onBack();
            return;
        }

        this.setState({
            step: this.steps[this.props.account-1][this.state.index-1],
            index: this.state.index-1,
        });
    }

    backAllStep() {
        document.location.href = '/profile/index';
        // this.props.onBack();
        return;
    }

    goEditSchool(id) {
        document.location.href = `/profile/scuola/${id}/edit`;
        // this.props.onBack();
        return;
    }

    getStepBottomBar() {
        const { profilo = false } = this.props;
        const statusLabel = (this.state.isRequestLoading) ? 'Attendi..' : profilo ? 'Salva e continua' : 'Salva e continua';
        return <article>
                    <button className={"btn-back left-button"} onClick={() => this.backStep()}><i className={"icon-prev"}></i> Indietro</button>
                    {this.state.isRequestLoading && <button className={"btn-next right-button disabled"} onClick={() => this.nextStep()}>{statusLabel}</button>}
                    {!this.state.isRequestLoading && <button className={"btn-next right-button"} onClick={() => this.nextStep()}>{statusLabel}</button>}
                </article>;
    }

    getStepBottomBarNoBack() {
        const { profilo = false } = this.props;

        const statusLabel = (this.state.isRequestLoading) ? 'Attendi..' : profilo ? 'Salva e continua' : 'Salva e continua';
        return <article>
                    <button className={"btn-next right-button"} onClick={() => this.nextStep()}> { statusLabel}</button>
                </article>;
    }

    renderFiglio(index) {
        const curr = (new Date()).getFullYear();
        const years = 30;
        return (<div className={"line-row"} key={index}>
                    <div className={"col-xs-12 col-sm-4 q_anni"}>Anno di nascita figlio { index+1 }</div>
                    <div className={"col-xs-12 col-sm-4"}>
                        {/*<FormInput type={"number"} placeholder={`Anno di nascita figlio ${ index+1 }`} name={`figli_${index}`} index={index} value={this.state.figli[index]} onChange={this.handleChange.bind(this)} />*/}
                        <FormSelect placeholder={"-"} name={`figli_${index}`} value={ this.state.figli[index] }
                            values={Array.from(new Array(years+1),(val,index)=>({key: curr-index, value: curr-index}))} required onChange={this.handleChange.bind(this)} />
                    </div>
                </div>);
    }

    renderFigli() {
        var children: any = [];


        console.log('this.state', this.state);

        if(this.state.numero_figli === undefined || this.state.numero_figli === 0 || this.state.figli == undefined || this.state.figli.length === 0)
            return;

        for(var i=0; i<this.state.numero_figli; i++) {
            children.push(this.renderFiglio(i));
        }

        return children;
    }

    getAnagrafica() {
        const account = this.props.account - 1;
        const provinceArray = shared.provincia.map((item) => {
            return {
                key: item.id,
                value: item.provincia
            }
        });
        const curr = (new Date()).getFullYear();
        let minAge = 16;
        if (this.props.account === 2 && !this.state.sono_un_genitore) {
            minAge = 13;
        }
        const years = 100-minAge;
        const endYear = curr - minAge;
        const phoneReq = !(account === 1 || account === 0);

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Anagrafica</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Inserisci i tuoi <strong>DATI PERSONALI</strong>.</h3>
                            </div>
                        </article>
                        <article>
                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <FormInput type={"text"} placeholder={"Nome"} label={"Nome"} required name={"nome"} value={ this.state.nome } onChange={this.handleChange.bind(this)} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <FormInput type={"text"} placeholder={"Cognome"} label={"Cognome"} required name={"cognome"} value={ this.state.cognome } onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-4">
                                    {
                                        this.state.data_nascita_gg &&
                                        <FormSelect placeholder={"Giorno"} label={"Data Di Nascita"} name={"data_nascita_gg"} value={ this.state.data_nascita_gg }
                                                    values={Array.from(new Array(31),(val,index)=>({key: index+1, value: index+1}))} required onChange={this.handleChange.bind(this)} />
                                    }

                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    {
                                        this.state.data_nascita_mm &&
                                        <FormSelect placeholder={"Mese"} name={"data_nascita_mm"} value={ this.state.data_nascita_mm }
                                                    values={Array.from(new Array(12),(val,index)=>({key: (index < 9) ? ('0' + parseInt(index +1)) : index+1 , value:(index < 9) ? ('0' + parseInt(index +1)) : index+1}))} required onChange={this.handleChange.bind(this)} />
                                    }
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    {
                                        this.state.data_nascita_yyyy &&
                                        <FormSelect placeholder={"Anno"} name={"data_nascita_yyyy"} value={ this.state.data_nascita_yyyy }
                                                    values={Array.from(new Array(years+1),(val,index)=>({key: endYear-index, value: endYear-index}))} required onChange={this.handleChange.bind(this)} />
                                    }
                                </div>
                            </div>
                            {!this.isGestore() && (
                            <>
                            {this.props.profilo && (
                            <div className="row">
                                <div className="col-xs-12">
                                    <FormInput type={"text"} placeholder={"Via, numero civico"} label={"Indirizzo"} name={"indirizzo"} value={ this.state.indirizzo } onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                            )}
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <FormInput type={"text"} placeholder={"Città"} label={"Città"} required name={"comune"} value={  this.state.comune } onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-4">
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                        (<FormSelect placeholder={"Provincia"} label={"Provincia"} name={"id_provincia"} values={provinceArray} value={ this.state.id_provincia } required onChange={this.handleChange.bind(this)} />)
                                    }
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user === null) &&
                                        (<FormSelect placeholder={"Provincia"} label={"Provincia"} name={"id_provincia"} values={provinceArray} required onChange={this.handleChange.bind(this)} />)
                                    }
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <FormInput type={"text"} placeholder={"CAP"} label={"CAP"} required name={"cap"} value={ this.state.cap } onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                            {this.props.profilo && (
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    {
                                        (this.state.countryValues && this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                        (<FormSelect placeholder={"Nazione"} label={"Nazione"} name={"nazione"} values={this.state.countryValues} value={ this.state.nazione } onChange={this.handleChange.bind(this)}
                                        required
                                        />)
                                    }
                                    {
                                        (this.state.countryValues && this.state.hasOwnProperty('user') && this.state.user === null) &&
                                        (<FormSelect placeholder={"Nazione"} label={"Nazione"} name={"nazione"} values={this.state.countryValues} onChange={this.handleChange.bind(this)} />)
                                    }
                                </div>
                            </div>
                            )}
                            <div className="row">
                                <div className="col-xs-12">
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                        <FormRadio size={"20px"} values={[{key: "M", value:"M"},{key: "F", value:"F"}]} name={"sesso"} value={ this.state.sesso } onChange={this.handleChange.bind(this)}>Sesso</FormRadio>
                                    }
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user === null) &&
                                        <FormRadio size={"20px"} values={[{key: "M", value:"M"},{key: "F", value:"F"}]} name={"sesso"} onChange={this.handleChange.bind(this)}>Sesso</FormRadio>
                                    }
                                </div>
                            </div>
                            </>
                            )}
                            <div className="row" style={{/*margin: 0*/}}>
                                <div className="col-xs-12 col-sm-5">
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                        <FormSelect label={"Numero di telefono"} values={prefissi} value={ this.state.telefono_pfx } required={phoneReq} name={"telefono_pfx"} onChange={this.handleChange.bind(this)} />
                                    }
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user === null) &&
                                        <FormSelect label={"Numero di telefono"} values={prefissi} required={phoneReq} name={"telefono_pfx"} onChange={this.handleChange.bind(this)} />
                                    }
                                </div>
                                <div className="col-xs-12 col-sm-5">
                                    <FormInput type={"text"} placeholder={"Numero"} name={"telefono_num"} value={ this.state.telefono_num } required onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    {(account === 2 || account === 3) && <>è il numero di telefono che sarà utilizzato per contattarti dalle persone che stanno cercando un profilo come il tuo.</>}
                                    {account === 4 && <>Potremmo chiamarti per verificare che tu sia il reale gestore della scuola.</>}
                                </div>
                            </div>
                        </article>
                        {!this.isGestore() && (<>
                        <div>
                            <hr />
                            <div className={"title-row"} style={{marginTop: "25px"}} >Foto di profilo</div>
                            <p>
                            è importante caricarla in modo che le persone possano associare un volto al tuo profilo, ma se non dovessi farlo sarà visualizzata semplicemente un'icona
                            </p>
                            <div className={"block-row"} style={{marginTop: "50px"}}>
                                <div className={"image-block"} style={{ position: 'relative' }} >
                                    {
                                        this.state.logo_url &&
                                        <img
                                            src={this.state.logo_url}
                                            style={ { width: 'auto', height: '100%', position: 'absolute', left: '50%', transform: 'translate(-50%, 0)', cursor: 'pointer' } }
                                            onClick={() => { this.setState({__editing_image: this.state.logo_url, __uploaded: true})} }
                                        />
                                    }
                                </div>
                                <div className={"btn-block"}>
                                    <form id="uploadLogoForm" ref={form => this.uploadLogoForm = form} method="post" style={{ opacity: 0, zIndex: 9999, cursor: 'pointer' }} >
                                        <input ref={input => this.fileUploadBtn = input} onChange={this.handleUploadLogo} type="file" id="uploadLogoUser" name="logoUser" accept="image/*" />
                                    </form>
                                    <button className={"btn-load"} style={ { position: 'absolute', zIndex: 1 } }>Carica file</button>
                                </div>
                            </div>
                        </div>
                        {this.state.__editing_image && this.state.__uploaded &&
                        <Modal open={true} title={"Ritaglia la tua foto"}>
                            <ImageEditor
                              save={ route('editImage', {obj: 'user', id: user.id} ) }
                              src={this.state.__editing_image}
                              onClose={() => { this.setState({__editing_image: null})} }
                              onComplete={(path) => { this.setState({
                                logo_url: path,
                                __editing_image: null
                              })} }
                              ratio={1}
                            />
                        </Modal>
                        }
                        </>)}
                        { this.props.account == 1 &&
                            <div>
                                <hr />
                                <div className={"title-row"}>I tuoi figli</div>
                                <div className={"line-row"} style={{marginTop: "50px"}}>
                                    <div className={"col-xs-12 col-sm-4 q_anni"}>Quanti figli hai?</div>
                                    {
                                        (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                        (this.state.numero_figli || this.state.numero_figli == 0) &&
                                        <div className={"col-xs-12 col-sm-4"}><FormSelect values={Array.from(new Array(10),(val,index)=>({key:index, value:index})).slice(1)} name={"numero_figli"} value={ this.state.numero_figli } onChange={this.handleChange.bind(this)} placeholder={"Numero figli"} /></div>
                                    }

                                </div>
                                {
                                    (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                                    this.renderFigli()
                                }
                            </div>
                        }
                        { ( this.props.account == 3 || this.props.account == 4) &&
                          (this.state.hasOwnProperty('user') && this.state.user !== null) &&
                           this.state.automunito !== undefined &&
                            <div>
                                {/*<div className={"title-row-grey"}>Autonomia di spostamento</div>*/}
                                <div className={"line-row"} style={{marginTop: "50px"}}>
                                    {
                                        <FormCheckBox name={"automunito"} value={this.state.automunito == 1} onChange={this.handleChange.bind(this)}>Sono automunito/a</FormCheckBox>
                                    }
                                    { 
                                        <FormCheckBox name={"patente_b"} value={this.state.patente_b == 1} onChange={this.handleChange.bind(this)}>Ho la patente B</FormCheckBox>
                                    }
                                </div>
                            </div>
                        }
                        { this.getStepBottomBarNoBack() }
                    </section>
                </div>
            </div>
        );
    }

    getDescrizione() {

        const needWrite = (100 - ((this.state.descrizione_descrizione) ? this.state.descrizione_descrizione.length : 0) );

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>La tua descrizione</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Titolo della tua descrizione</h3>
                                <div className={"answer"}>
                                    <h4>Questo è il tuo biglietto da visita. Cosa ti contraddistingue davvero?
                                        {this.isDocente() &&
                                        <ol style={{listStyleType: "decimal"}}>
                                            <li>Titolo di studio (laurea, diploma)</li>
                                            <li>In che città/quartiere lavori</li>
                                            <li>Quali materie insegni</li>
                                        </ol>
                                        }
                                        {this.isTata() &&
                                        <ol style={{listStyleType: "decimal"}}>
                                            <li>In che città lavori</li>
                                            <li>Quanti anni hai</li>
                                            <li>Che tipo di servizio offri (part-time, full-time, occasionale)</li>
                                        </ol>
                                        }
                                    </h4>
                                    <div style={{maxWidth: "300px"}}>
                                        <FormInput type={"text"} placeholder={"Titolo descrizione"} name={"titolo_descrizione"} value={this.state.titolo_descrizione} onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>La tua descrizione</h3>
                                <div className={"answer"}>
                                    <h4>
                                        La tua introduzione è molto importante. Parlaci di te, delle tue caratteristiche. Spiegaci come mai lavorare con te è speciale.<br /><br />
                                        La descrizione non può contenere i tuoi dati sensibili: numero di telefono, cognome, email, link a social network o qualsiasi piattaforma di promozione personale.<br />
                                        I profili non conformi saranno moderati o rimossi dal team di Schoolvisor.
                                    </h4>
                                    {/*
                                    @removed: caratteri mini
                                    <div className="description-counter" style={ { paddingBottom: '10px', paddingTop: '10px', textAlign: 'right', display: (needWrite > 0) ? 'block' : 'none' } }>Devi scrivere ancora { needWrite } caratteri.</div>
                                    <div className="description-counter" style={ { paddingBottom: '10px', paddingTop: '10px', textAlign: 'right', color: 'green', display: (needWrite <= 0) ? 'block' : 'none' } }>PERFETTO.</div>
                                    */}
                                    <div>
                                        <FormInput type={"textarea"} height={"240px"} name={"descrizione_descrizione"} value={this.state.descrizione_descrizione} onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    mapListCheckedCheckBox(item) {
        if(item.items !== undefined) {
            return <div>
                <FormCheckBox key={item.key} name={item.name} value={this.state[item.name] == 1} onChange={this.handleChange.bind(this)}>{ item.value }</FormCheckBox>
                {
                    (item.hasOwnProperty('type') && item.type === 'optional' && this.state[item.name] == 1) &&
                    <div style={{marginTop: "0px"}}>
                        { item.items.map(this.renderSecondLevelCheckedCheck.bind(this))}
                    </div>
                }
                {
                    (! item.hasOwnProperty('type')) &&
                    <div style={{marginTop: "0px"}}>
                        { item.items.map(this.renderSecondLevelCheckedCheck.bind(this))}
                    </div>
                }
            </div>
        } else {
            return <FormCheckBox key={item.key} name={item.name} value={this.state[item.name] == 1} onChange={this.handleChange.bind(this)}>{ item.value }</FormCheckBox>
        }
    }

    renderSecondLevelCheckedCheck(item, level) {
        return <FormCheckBox key={item.key} name={item.name} level={2} value={this.state[item.name] == 1} onChange={this.handleChange.bind(this)}>{ item.value }</FormCheckBox>
    }


    getFormazione() {
        let titoli = [
            {
                key: "1",
                value: "Scuola dell'obbligo"
            },
            {
                key: "2",
                value: "Diploma"
            },
            {
                key: "3",
                value: "Laurea"
            }
        ];

        let certificati = [
            {
                key: "primo",
                name: "_certificati_primo_soccorso",
                value: "Primo soccorso pediatrico (tecniche base di primo soccorso)"
            },
            {
                key: "bls",
                name: "_certificati_bls",
                value: "Attestato BLS defibrillatore semiautomatico esterno (AED)"
            },
            {
                key: "educatore",
                name: "_certificati_educatore",
                value: "Attestato educatore di prima infanzia"
            },
            {
                key: "animatore",
                name: "_certificati_animatore",
                value: "Animatore d'infanzia"
            }
        ];


        let lingue = [
            {
                key: "italiano",
                name: "_certificati_italiano",
                value: "Italiano",
                items: [
                    {
                        key: "madrelingua",
                        name: "_certificati_italiano_madrelingua",
                        value: "Madrelingua",
                        relateds: "_certificati_italiano"
                    }
                ],
                type: 'optional'
            },
            {
                key: "inglese",
                name: "_certificati_inglese",
                value: "Inglese",
                items: [
                    {
                        key: "mandrelingua",
                        name: "_certificati_inglese_madrelingua",
                        value: "Madrelingua",
                        relateds: "_certificati_inglese"
                    }
                ],
                type: 'optional'
            },
            {
                key: "francese",
                name: "_certificati_francese",
                value: "Francese",
                items: [
                    {
                        key: "mandrelingua",
                        name: "_certificati_francese_madrelingua",
                        value: "Madrelingua",
                        relateds: "_certificati_francese"
                    }
                ],
                type: 'optional'
            },
            {
                key: "spagnolo",
                name: "_certificati_spagnolo",
                value: "Spagnolo",
                items: [
                    {
                        key: "madrelingua",
                        name: "_certificati_spagnolo_madrelingua",
                        value: "Madrelingua",
                        relateds: "_certificati_spagnolo"
                    }
                ],
                type: 'optional'
            },
            {
                key: "tedesco",
                name: "_certificati_tedesco",
                value: "Tedesco",
                items: [
                    {
                        key: "madrelingua",
                        name: "_certificati_tedesco_madrelingua",
                        value: "Madrelingua",
                        relateds: "_certificati_tedesco"
                    }
                ],
                type: 'optional'
            }
        ];

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Formazione & certificati</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Qual è il tuo ultimo titolo di studio?</h3>
                                <div className={"answer"}>
                                    <FormRadio values={titoli} list={true} name={"_certificati_ultimo_titolo"} value={this.state._certificati_ultimo_titolo} onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Hai dei certificati o degli attestati?</h3>
                                <div className={"answer"}>
                                    {
                                        certificati.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Lingue conosciute</h3>
                                <div className={"answer"}>
                                    {
                                        lingue.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                            <div style={{ marginTop: "30px", maxWidth:"300px" }}>
                                <FormInput type={"text"} placeholder={"Indicare altre lingue"} label={"Altro"} name={"_certificati_altre_lingue"} value={this.state._certificati_altre_lingue} onChange={(this.handleChange.bind(this))} />
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    mapListUniversita(uni) {
        return <ListItem text={uni.name + ' - ' + uni.desc} icons={["icon-delete"]} key={uni.key} actions={[() => this.deleteFormazione(uni.key)]} />
    }

    getFormazioneP() {
        let tipologie = [
            {
                key: "1",
                value: "Licenza media"
            },
            {
                key: "2",
                value: "Liceo artistico"
            },
            {
                key: "3",
                value: "Liceo classico"
            },
            {
                key: "4",
                value: "Liceo linguistico"
            },
            {
                key: "5",
                value: "Liceo musicale e coreutico"
            },
            {
                key: "6",
                value: "Liceo scientifico"
            },
            {
                key: "7",
                value: "Liceo scienze umane"
            },
            {
                key: "11",
                value: "Liceo magistrale"
            },
            {
                key: "8",
                value: "Istituto tecnico"
            },
            {
                key: "9",
                value: "Istituto professionale"
            },
        ];

        const provinceArray = shared.provincia.map((item) => {
            return {
                key: item.id,
                value: item.provincia
            }
        })


        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>La tua formazione</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Diploma</h3>
                                <div className={"answer"}>
                                    <h4>Che diploma hai conseguito?</h4>
                                    <div className={"maxw"}>
                                        <FormSelect values={tipologie} placeholder={"Selezionare"} name={"formazione_diploma"} value={this.state.formazione_diploma} onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Formazione universitaria</h3>
                                <div className={"answer"}>
                                    <div>
                                        {    this.state.formazione_universita !== undefined &&
                                            this.state.formazione_universita.map(this.mapListUniversita.bind(this))
                                        }
                                    </div>
                                    <div style={{ marginTop: "30px", height:"150px" }}>
                                        <button className={"btn-add-grey right-button"} onClick={() => this.setState({modal: true, tmodal: 2})}>AGGIUNGI</button>
                                    </div>
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
                { this.state.modal && this.state.tmodal==1 && this.getModalAggiungiScuola() }
                { this.state.modal && this.state.tmodal==2 && this.getFormazioneModal() }
            </div>
        );
    }

    getMiniCv() {
        let esperienze = [
            {
                key: "0",
                value: "Non ho esperienza"
            },
            {
                key: "1",
                value: "Meno di 1 anno"
            },
            {
                key: "2",
                value: "Da 1 a 3 anni"
            },
            {
                key: "3",
                value: "Da più di 3 anni"
            }
        ];

        let asilo = [
            {
                key: "si",
                value: "SI"
            },
            {
                key: "no",
                value: "NO"
            }
        ];

        let bambini = [
            {
                key: "0M",
                name: "_formazione_esperienza_0m",
                value: "Età 0-9 mesi"
            },
            {
                key: "10M",
                name: "_formazione_esperienza_10m",
                value: "Età da 10 a 18 mesi"
            },
            {
                key: "19M",
                name: "_formazione_esperienza_19m",
                value: "Età da 19 a 36 mesi"
            },
            {
                key: "3A",
                name: "_formazione_esperienza_3a",
                value: "Età da 3 a 6 anni"
            },
            {
                key: "7A",
                name: "_formazione_esperienza_7a",
                value: "Età da 7 a 10 anni"
            },
            {
                key: "11A",
                name: "_formazione_esperienza_11a",
                value: "Età da 11 a 13 anni"
            }
        ];

        let attivita = [
            {
                key: "lab",
                name: "_formazione_ludico",
                value: "Laboratori ludico-creativi"
            },
            {
                key: "mov",
                name: "_formazione_movimento",
                value: "Giochi di movimento"
            },
            {
                key: "let",
                name: "_formazione_lettura",
                value: "Lettura"
            },
            {
                key: "tru",
                name: "_formazione_truccabimbi",
                value: "Truccabimbi"
            },
            {
                key: "feste",
                name: "_formazione_feste",
                value: "Feste a tema"
            },
            {
                key: "cac",
                name: "_formazione_caccia",
                value: "Caccia al tesoro"
            },
            {
                key: "cor",
                name: "_formazione_corsi",
                value: "Corsi di lingue"
            },
            {
                key: "mas",
                name: "_formazione_massaggio",
                value: "Massaggio infantile"
            },
            {
                key: "aiuto",
                name: "_formazione_comunicazione",
                value: "Aiuto alla comunicazione intergenerazionale"
            },
            {
                key: "wed",
                name: "_formazione_wedding",
                value: "Wedding bag/laboratorio per matrimonio"
            },
            {
                key: "att",
                name: "_formazione_spiaggia",
                value: "Attività da spiaggia"
            },
            {
                key: "stru",
                name: "_formazione_musica",
                value: "Strumenti musicali"
            },
            {
                key: "comp",
                name: "_formazione_compiti",
                value: "Aiuto compiti"
            }
        ];

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Mini CV</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Da quanto tempo lavori con i bambini? <span className="required">*</span></h3>
                                <div className={"answer"}>
                                    <FormRadio values={esperienze} list={true} name={"_formazione_lavoro_bambini"} value={this.state._formazione_lavoro_bambini} onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Hai esperienza di lavoro in asilo? <span className="required">*</span></h3>
                                <div className={"answer"}>
                                    <FormRadio values={asilo} name={"_formazione_lavoro_asilo"} value={this.state._formazione_lavoro_asilo} onChange={this.handleChange.bind(this)} />
                                </div>
                            </div>
                        </article>
                        <article style={{ marginTop: '0px' }}>
                            <div className={"block-qa"}>
                                <h3>Ho esperienza con bambini di</h3>
                                <div className={"answer"}>
                                    {
                                        bambini.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Attività proposte per i bambini</h3>
                                <div className={"answer"}>
                                    {
                                        attivita.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    getAltreInfo() {
        let peculiarita = [
            /*{
                key: "pat",
                name: "_altre_info_patente",
                value: "Ho la patente"
            },*/
            {
                key: "fum",
                name: "_altre_info_fumatore",
                value: "NON sono un fumatore/fumatrice"
            },
            {
                key: "nuo",
                name: "_altre_info_nuotare",
                value: "So nuotare"
            }
        ];

        let cucine = [
            {
                key: "ita",
                name: "_altre_info_cucina_italiana",
                value: "Cucina italiana"
            },
            {
                key: "int",
                name: "_altre_info_cucina_internazionale",
                value: "Cucina internazionale"
            },
            {
                key: "vege",
                name: "_altre_info_cucina_vegetariana",
                value: "Cucina vegetariana"
            },
            {
                key: "vega",
                name: "_altre_info_cucina_vegana",
                value: "Cucina vegana"
            },
            {
                key: "into",
                name: "_altre_info_cucina_intolleranze",
                value: "Cucina per intolleranze alimentari"
            }
        ];

        let utile = [
            {
                key: "pul",
                name: "_altre_info_pulizie",
                value: "Fare le pulizie"
            },
            {
                key: "dog",
                name: "_altre_info_dog",
                value: "Dog sitter"
            },
            {
                key: "cuci",
                name: "_altre_info_cucina_bambini",
                value: "Cucina per bambini",
                items: cucine,
                type: 'optional'
            }
        ];

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Altre informazioni interessanti</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Peculiarità</h3>
                                <div className={"answer"}>
                                    {
                                        peculiarita.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>In casa posso essere utile a</h3>
                                <div className={"answer"}>
                                    {
                                        utile.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    getLavorare() {
        let lavorare = [
            {
                key: "prol",
                name: "_lavorare_prolungati",
                value: "Per periodi prolungati"
            },
            {
                key: "occ",
                name: "_lavorare_occasionali",
                value: "Per periodi occasionali"
            },
            {
                key: "part",
                name: "_lavorare_part",
                value: "Part Time"
            },
            {
                key: "full",
                name: "_lavorare_full",
                value: "Full Time"
            },
            {
                key: "vac",
                name: "_lavorare_vacanze",
                value: "Durante le vacanze scolastiche"
            }
        ];

        let disponibilita = [
            {
                key: "famig",
                name: "_lavorare_famiglia",
                value: "Con la famiglia in vacanza"
            },
            {
                key: "pari",
                name: "_lavorare_pari",
                value: "Posso lavorare alla pari"
            }
        ];

        const geoAutocompleteControlParams = {
            placeholder: 'Inserisci indirizzo...'
        };

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Quando posso lavorare?</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Posso lavorare</h3>
                                <div className={"answer"}>
                                    {
                                        lavorare.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>
                                    Il tuo indirizzo
                                    <span className="required">*</span>
                                </h3>
                                <div className={"answer"}>
                                    <h4>
                                        Indicaci il tuo indirizzo.<br />
                                        Sarà per noi più facile farti lavorare con le mamme della tua zona.<br />
                                        <strong>Il tuo indirizzo completo non verrà mai reso pubblico</strong>
                                    </h4>
                                    <div style={{ marginTop: "30px", maxWidth:"300px", position: 'relative'}}>
                                        <div style={{ visibility: 'hidden', 'height': '0px' }} >
                                            <FormInput type={"text"} placeholder={"Nome"} label={"Indirizzo"} name="_lezioni_indirizzo" value={ this.state._lezioni_indirizzo } onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <GeoAutocompleteControl placeholder={geoAutocompleteControlParams.placeholder} onSuggestSelect={this.onSuggestSelect.bind(this)} value_str={this.state._lezioni_indirizzo} />

                                        {/*<span style={ { cursor: 'pointer', display: 'inline-block', position: 'absolute', right: '-20%', bottom: '10px', fontSize: '14px' } } onClick={() => { document.getElementsByClassName('GeoAutocompleteControl-input')[0].value = ''; this.setState({ _lezioni_google: null }) }} >Reset</span>*/}
                                    </div>
                                    {
                                        this.state._lezioni_google &&
                                        this.state._lezioni_indirizzo !== undefined &&
                                        this.state._lezioni_indirizzo !== '0' &&
                                        <div className="Map">
                                            <MapContainer name={this.state._lezioni_google.name}
                                                          zoom={this.state._lezioni_google.zoom}
                                                          center={this.state._lezioni_google.center}
                                                          lat={this.state._lezioni_google.lat}
                                                          lng={this.state._lezioni_google.lng} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Sono disponibile a trasferirmi</h3>
                                <div className={"answer"}>
                                    {
                                        disponibilita.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    listMaterie(materia) {
        console.log('listMaterie', materia);
        return <ListItem text={materia.name + " " + materia.scuole} icons={["icon-delete"]} key={materia.key} actions={[() => this.deleteMateria(materia.key)]} />
    }

    addMateria(res) {
        let result = res;
        let arr: any[] = [];

        if(this.state._materie_insegnate !== undefined) {
            result.key = this.state._materie_insegnate.length;
            arr = this.state._materie_insegnate;
        }
        else {
            result.key = 0;
        }

        arr.push(result);
        this.setState({modal: false, _materie_insegnate: arr});
    }

    deleteMateria(key) {
        let arr: any[] = [];
        let new_arr: any[] = [];

        if(this.state._materie_insegnate !== undefined) {
            arr = this.state._materie_insegnate;
            arr.splice(key, 1);

            for(var i=0; i<arr.length; i++) {
                var tmp = arr[i];
                tmp.key = i;
                new_arr.push(tmp);
            }

            this.setState({_materie_insegnate: new_arr});
        }
    }

    getMaterie() {
        let max = window['CONFIG'].tariffa_alert.docente;
        const hasWarning = (type) => {
            const v = this.state[`_tariffe_${type}`];
            if (v && v > max) return <div className="alert alert-warning">Sei sicuro che la tariffa oraria sia di {Formatters.Price({val: v, currency: ''})} &euro;?</div>;
            return null;
        }
        
        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Materie insegnate</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Le materie che insegni
                                    <button className={"btn-add-grey right-button"} onClick={() => this.setState({modal: true})}>AGGIUNGI MATERIA</button>
                                </h3>
                                <div className={"answer"}>
                                    {    this.state._materie_insegnate !== undefined &&
                                            this.state._materie_insegnate.map(this.listMaterie.bind(this))
                                        }
                                </div>
                            </div>
                        </article>

                        <article>
                            <div className={"block-qa"}>
                                <h3>Le tue tariffe</h3>
                                <div className="answer">
                                    <h4>Puoi indicare prezzi differenti a seconda del livello a cui insegni.</h4>
                                </div>
                                <table className="table">
                                <tbody>
                                    <tr>
                                        <td>Prezzo orario elementari</td>
                                        <td>
                                            <div className={"maxw"}>
                                                <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffe_elementari"} value={this.state._tariffe_elementari} onChange={this.handleChange.bind(this)} />
                                                {hasWarning('elementari')}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Prezzo orario scuole medie</td>
                                        <td>
                                            <div className={"maxw"}>
                                                <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffe_medie"} value={this.state._tariffe_medie} onChange={this.handleChange.bind(this)} />
                                                {hasWarning('medie')}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Prezzo orario scuole superiori</td>
                                        <td>
                                            <div className={"maxw"}>
                                                <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffe_superiori"} value={this.state._tariffe_superiori} onChange={this.handleChange.bind(this)} />
                                                {hasWarning('superiori')}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Prezzo orario università</td>
                                        <td>
                                            <div className={"maxw"}>
                                                <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffe_universita"} value={this.state._tariffe_universita} onChange={this.handleChange.bind(this)} />
                                                {hasWarning('universita')}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Prezzo orario altre tipologie</td>
                                        <td>
                                            <div className={"maxw"}>
                                                <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffe_altre_tipologie"} value={this.state._tariffe_altre_tipologie} onChange={this.handleChange.bind(this)} />
                                                {hasWarning('altre_tipologie')}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </article>

                        { this.getStepBottomBar() }
                    </section>
                </div>
                {this.state.modal && this.getMateriaModel()}
            </div>
        );
    }


    getFormazioneModal() {
        return (
            <div className={"row"}>
                <ModalFormazione header={"La tua formazione universitaria"}
                                 onCancel={() => this.setState({modal: false})} onSave={this.addFormazione.bind(this)}>
                </ModalFormazione>
            </div>
        );
    }

    validateFormazioneModal() {
        let isValid = true;

    }

    addFormazione(res) {
        let result = res;
        let arr: any[] = [];

        if(this.state.formazione_universita !== undefined) {
            result.key = this.state.formazione_universita.length;
            arr = this.state.formazione_universita;
        }
        else {
            result.key = 0;
        }

        arr.push(result);
        this.setState({modal: false, formazione_universita: arr});
    }

    deleteFormazione(key) {
        let arr: any[] = [];
        let new_arr: any[] = [];

        if(this.state.formazione_universita !== undefined) {
            arr = this.state.formazione_universita;
            arr.splice(key, 1);

            for(var i=0; i<arr.length; i++) {
                var tmp = arr[i];
                tmp.key = i;
                new_arr.push(tmp);
            }

            this.setState({formazione_universita: new_arr});
        }
    }

    getLezioniPrivate() {
        let luoghi = [
            {
                key: "casatua",
                name: "_lezioni_casa_tua",
                value: "Casa tua",
            },
            {
                key: "casastudente",
                name: "_lezioni_casa_studente",
                value: "Casa dello studente"
            },
            {
                key: "luogopubblico",
                name: "_lezioni_pubblico",
                value: "Luogo pubblico (es. biblioteca, università)"
            },
            {
                key: "online",
                name: "_lezioni_online",
                value: "Online"
            }
        ];

        const geoAutocompleteControlParams = {
            placeholder: 'Inserisci indirizzo...'
        };

        return (
            <div className="row">
                <div className="boxed-div">
                <div className="vertical_line"> </div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Dove impartisci lezioni private?</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Luoghi di lezione</h3>
                                <div className={"answer"}>
                                    <h4>Seleziona i luoghi in cui vuoi erogare le tue lezioni. Puoi scegliere più location.</h4>
                                    {
                                        luoghi.map(this.mapListCheckedCheckBox.bind(this))
                                    }
                                    <div style={{ marginTop: "30px", maxWidth:"300px" }}>
                                        <FormInput type={"text"} placeholder={"Nome SKYPE"} icon={"icon-skype"} name="_lezioni_skype" value={ this.state._lezioni_skype } onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>
                                    Il tuo indirizzo
                                    <span className="required">*</span>
                                </h3>
                                <div className={"answer"}>
                                    <h4>
                                        Indicaci il tuo indirizzo.<br />
                                        Sarà per noi più facile farti lavorare con le mamme della tua zona.<br />
                                        <strong>Il tuo indirizzo completo non verrà mai reso pubblico</strong>
                                    </h4>
                                    <div style={{ marginTop: "30px", maxWidth:"300px", position: 'relative'}}>
                                        <div style={{ visibility: 'hidden', 'height': '0px' }} >
                                            <FormInput type={"text"} placeholder={"Nome"} label={"Indirizzo"} name="_lezioni_indirizzo" value={ this.state._lezioni_indirizzo } onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <GeoAutocompleteControl placeholder={geoAutocompleteControlParams.placeholder} onSuggestSelect={this.onSuggestSelect.bind(this)} value_str={this.state._lezioni_indirizzo} />

                                        {/*<span style={ { cursor: 'pointer', display: 'inline-block', position: 'absolute', right: '-20%', bottom: '10px', fontSize: '14px' } } onClick={() => { document.getElementsByClassName('GeoAutocompleteControl-input')[0].value = ''; this.setState({ _lezioni_google: null }) }} >Reset</span>*/}
                                    </div>
                                    {
                                        this.state._lezioni_google &&
                                        this.state._lezioni_indirizzo !== undefined &&
                                        this.state._lezioni_indirizzo !== '0' &&
                                        <div className="Map">
                                            <MapContainer name={this.state._lezioni_google.name}
                                                          zoom={this.state._lezioni_google.zoom}
                                                          center={this.state._lezioni_google.center}
                                                          lat={this.state._lezioni_google.lat}
                                                          lng={this.state._lezioni_google.lng} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    onSuggestSelect(suggest){
        console.log(suggest);

        if(suggest === undefined || ! suggest.hasOwnProperty('latlng')) {
            return;
        }

        const google = {
            center: suggest.latlng,
            zoom: 16,
            name: suggest.value,
            lat: suggest.latlng.lat,
            lng: suggest.latlng.lng,
        };
        let val = {
            nazione: suggest.country,
            nazioneCode: suggest.countryCode,
            regione: suggest.administrative,
            nome: suggest.name,
            cap: suggest.postcode,
            tipo: suggest.type,
        } as any;
        if (suggest.type === "city") {
            val.comune = suggest.name;
        }
        if (suggest.type === "address") {
            val.indirizzo = suggest.name;
            val.comune = suggest.city;
        }

        console.log('Google', google, 'Val', val);

        document.getElementsByName('_lezioni_indirizzo')[0].value = google.name;

        this.setState({ _lezioni_google: google, _lezioni_indirizzo: google.name, _lezioni_indirizzo_data: val });
    }

    getTariffa() {
        let max = window['CONFIG'].tariffa_alert.tata;
        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Tariffe</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>La mia tariffa oraria <span className={"required"}>*</span></h3>
                                <div className={"answer"}>
                                    <div className={"maxw"}>
                                        <FormInput type={"number"} icon={"icon-euro_filled"} name={"_tariffa_mia"} value={this.state._tariffa_mia} onChange={this.handleChange.bind(this)} />
                                    </div>
                                    {this.state._tariffa_mia && this.state._tariffa_mia > max && <div className="alert alert-warning">Sei sicuro che la tua tariffa oraria sia di {Formatters.Price({val: this.state._tariffa_mia, currency: ''})} &euro;?</div>}
                                    <h4>I prezzi sono indicativi e rappresentano un valore medio di partenza da concordare tramite contatto. <br /><br />
                                    {!__BETA &&
                                        <>Passa a PREMIUM per rendere visibili i tuoi dati di contatto.</>
                                    }
                                    </h4>
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    getMateriaModel() {

        console.log('this.state.subjectValues', this.state.subjectValues);
        return (
            <div className={"row"}>
                <ModalMateria header={"Aggiungi materia insegnata"}
                              items={this.state.subjectValues}
                                 onCancel={() => this.setState({modal: false})} onSave={this.addMateria.bind(this)}>
                </ModalMateria>
            </div>
        );
    }

    getModalCompetenza() {

        let template = null;

        if(this.state.tmp_competenza === null || this.state.tmp_competenza === undefined) {
            template = (
                <div className={"row"}>
                    <ModalCompetenza header={"Aggiungi competenza"}
                                     items={this.state.skillValues}
                                     onCancel={() => this.setState({modal: false, tmp_competenza: null})} onSave={this.addCompetenza.bind(this)}>
                    </ModalCompetenza>
                </div>
            );
        } else {
            template = (
                <div className={"row"}>
                    <ModalCompetenza header={"Modifica competenza"}
                                     items={this.state.skillValues}
                                     onCancel={() => this.setState({modal: false, tmp_competenza: null})}
                                     competenza={this.state.tmp_competenza}
                                     onEdit={this.editCompetenza.bind(this)}>
                    </ModalCompetenza>
                </div>
            );
        }
        return (
            template
        );


        return (
            <div className={"row"}>
                <ModalCompetenza header={"Aggiungi competenza"}
                              onCancel={() => this.setState({modal: false})} onSave={this.addCompetenza.bind(this)}>
                </ModalCompetenza>
            </div>
        );
    }

    getModalAggiungiScuola() {
        return (
            <div className={"row"}>
                <ModalAggiungiScuola header={"Aggiungi scuola"}
                              onCancel={() => this.setState({modal: false})} onSave={this.addNuovaScuola.bind(this)}>
                </ModalAggiungiScuola>
            </div>
        );
    }

    getModalLingua() {

        let template = null;

        if(this.state.tmp_lingua === null || this.state.tmp_lingua === undefined) {
            template = (
                <div className={"row"}>
                    <ModalLingua header={"Aggiungi lingua straniera"}
                                 items={this.state.languageValues}
                                 onCancel={() => this.setState({modal: false, tmp_lingua: null})} onSave={this.addLingua.bind(this)}>
                    </ModalLingua>
                </div>
            );
        } else {
            template = (
                <div className={"row"}>
                    <ModalLingua header={"Aggiungi lingua straniera"}
                                 items={this.state.languageValues}
                                 onCancel={() => this.setState({modal: false, tmp_lingua: null})}
                                 lingua={this.state.tmp_lingua}
                                 onEdit={this.editLingua.bind(this)}
                    >
                    </ModalLingua>
                </div>
            );
        }
        return (
            template
        );
    }

    editLingua(res) {
        let result = res;
        let _lingue_lingue = this.state._lingue_lingue

        console.log('update result', result);

        if(_lingue_lingue !== undefined) {
            _lingue_lingue[result.key] = result;
        }

        this.setState({modal: false, _lingue_lingue, tmp_lingua: null});
    }

    addLingua(res) {
        let result = res;
        let arr: any[] = [];

        if(this.state._lingue_lingue !== undefined) {
            result.key = this.state._lingue_lingue.length;
            arr = this.state._lingue_lingue;
        }
        else {
            result.key = 0;
        }

        arr.push(result);
        this.setState({modal: false, _lingue_lingue: arr});
    }

    deleteLingua(key) {
        let arr: any[] = [];
        let new_arr: any[] = [];

        if(this.state._lingue_lingue !== undefined) {
            arr = this.state._lingue_lingue;
            arr.splice(key, 1);

            for(var i=0; i<arr.length; i++) {
                var tmp = arr[i];
                tmp.key = i;
                new_arr.push(tmp);
            }

            this.setState({_lingue_lingue: new_arr});
        }
    }

    editCompetenza(res) {
        let result = res;
        let _lingue_competenze = this.state._lingue_competenze;

        console.log('update result', result);

        if(_lingue_competenze !== undefined) {
            _lingue_competenze[result.key] = result;
        }

        this.setState({modal: false, _lingue_competenze, tmp_competenza: null});
    }

    addCompetenza(res) {
        let result = res;
        let arr: any[] = [];

        if(this.state._lingue_competenze !== undefined) {
            result.key = this.state._lingue_competenze.length;
            arr = this.state._lingue_competenze;
        }
        else {
            result.key = 0;
        }

        arr.push(result);

        console.log('add competenza', res);

        this.setState({modal: false, _lingue_competenze: arr});
    }

    deleteCompetenza(key) {
        let arr: any[] = [];
        let new_arr: any[] = [];

        if(this.state._lingue_competenze !== undefined) {
            arr = this.state._lingue_competenze;
            arr.splice(key, 1);

            for(var i=0; i<arr.length; i++) {
                var tmp = arr[i];
                tmp.key = i;
                new_arr.push(tmp);
            }

            this.setState({_lingue_competenze: new_arr});
        }
    }

    addNuovaScuola(res) {
        let result = res;
        
        this.setState({
            modal: false,
        });
        notify({
            type: 'success',
            text: result.data.message
        })
    }

    listLingue(lingua) {
        return <ListItem text={lingua.lingua + " - Livello " + lingua.livello} subtext={(lingua.titolo_certificazione !== '' && lingua.titolo_certificazione !== undefined) ? (`Certificazione: ${lingua.titolo_certificazione}`) : ('') } icons={["icon-edit_file", "icon-delete"]} key={lingua.key} actions={[() => { console.log('lingua', lingua); this.setState({ modal: true, tmodal: 1, tmp_lingua: lingua }); }, () => this.deleteLingua(lingua.key)]} />
    }

    listCompetenze(competenza) {
        return <ListItem text={competenza.nome} icons={["icon-edit_file", "icon-delete"]} actions={[() => { console.log('competenza', competenza); this.setState({ modal: true, tmodal: 2, tmp_competenza: competenza }); }, () => this.deleteCompetenza(competenza.key)]} key={competenza.key} />
    }

    getLingue() {
        let anni = Array.from(new Array(10),(val,index)=>({key:index, value:index.toString()}));
        anni.push({key: 11, value: "> 9"});

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Lingue e competenze</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Lingue straniere conosciute
                                    <button className={"btn-add-grey right-button"} onClick={() => this.setState({modal: true, tmodal: 1})}>AGGIUNGI LINGUA</button>
                                </h3>
                                <div className={"answer"}>
                                    <div style={{marginTop: "30px"}}>
                                        {    this.state._lingue_lingue !== undefined &&
                                            this.state._lingue_lingue.map(this.listLingue.bind(this))
                                        }
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Altre competenze
                                    <button className={"btn-add-grey right-button"} onClick={() => this.setState({modal: true, tmodal: 2})}>AGGIUNGI COMPETENZA</button>
                                </h3>
                                <div className={"answer"}>
                                    <h4>Indica se hai altre competenze o certificazioni.<br />Aumentano il tuo grado di professionalità.</h4>
                                    <div style={{marginTop: "30px"}}>
                                        {
                                            this.state._lingue_competenze !== undefined &&
                                            this.state._lingue_competenze.map(this.listCompetenze.bind(this))
                                        }
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Esperienza nell'insegnamento</h3>
                                <div className={"answer"}>
                                    <h4>Indica da quanti anni insegni.</h4>
                                    <div className={"maxw"}>
                                        <FormSelect values={anni} placeholder={"Anni di esperienza"} name="_lingue_anni" value={ this.state._lingue_anni } onChange={this.handleChange.bind(this)}  />
                                    </div>
                                </div>
                            </div>
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                </div>

                { this.state.modal && this.state.tmodal==1 && this.getModalLingua() }
                { this.state.modal && this.state.tmodal==2 && this.getModalCompetenza() }
            </div>
        );
    }

    addEsperienza(res) {
        let result = res;
        let arr: any[] = [];

        if(this.state._esperienze_lavorative !== undefined) {
            result.key = this.state._esperienze_lavorative.length;
            arr = this.state._esperienze_lavorative;
        }
        else {
            result.key = 0;
        }

        arr.push(result);
        this.setState({modal: false, _esperienze_lavorative: arr});
    }

    updateEsperienza(res) {
        let result = res;
        let _esperienze_lavorative = this.state._esperienze_lavorative

        console.log('update result', result);

        if(_esperienze_lavorative !== undefined) {
            _esperienze_lavorative[result.key] = result;
        }

        this.setState({modal: false, _esperienze_lavorative, tmp_esperienza: null});
    }

    deleteEsperienza(key) {
        let arr: any[] = [];
        let new_arr: any[] = [];

        if(this.state._esperienze_lavorative !== undefined) {
            arr = this.state._esperienze_lavorative;
            arr.splice(key, 1);

            for(var i=0; i<arr.length; i++) {
                var tmp = arr[i];
                tmp.key = i;
                new_arr.push(tmp);
            }

            this.setState({_esperienze_lavorative: new_arr});
        }
    }

    getEsperienze() {
        let esperienze = [
            {
                key: "1",
                name: "FISICA",
                from: "05/2016",
                to: "06/2018",
                descr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            },
            {
                key: "2",
                name: "CHIMICA",
                from: "05/2016",
                to: "06/2018",
                descr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            }
        ];

        let esperienze = this.state._esperienze_lavorative;

        if(esperienze !== undefined && esperienze.length > 0) {
            esperienze = orderBy(esperienze, ['from'], 'asc');
        }

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Esperienze Lavorative</h3>
                        </header>
                        <article>
                            <button className={"btn-add-grey right-button"} onClick={ () => { this.setState({ modal: true }) } }  >AGGIUNGI</button>
                        </article>
                        {
                            esperienze !== undefined &&
                            esperienze.length > 0 &&
                            esperienze.map((esperienza) => {

                                return (
                                    <article key={esperienza.key}>
                                        <Esperienza esperienza={esperienza}
                                                    onDelete={() => {
                                                        let arr: any[] = [];
                                                        let new_arr: any[] = [];
                                                        const key = esperienza.key;
                                                        if(this.state._esperienze_lavorative !== undefined) {
                                                            arr = this.state._esperienze_lavorative;
                                                            arr.splice(key, 1);

                                                            for(var i=0; i<arr.length; i++) {
                                                                var tmp = arr[i];
                                                                tmp.key = i;
                                                                new_arr.push(tmp);
                                                            }

                                                            this.setState({_esperienze_lavorative: new_arr});
                                                        }
                                                    }}

                                                    onEdit={() => {
                                                        console.log('esperienza', esperienza);
                                                        this.setState({ modal: true, tmp_esperienza: esperienza });
                                                    }}
                                        />
                                    </article>
                                )
                            })
                        }
                        { this.getStepBottomBar() }
                    </section>
                    { this.state.modal && this.getEsperienzeModal() }
                </div>
            </div>
        );
    }


    getEsperienzeModal() {

        let template = null;

        if(this.state.tmp_esperienza === null || this.state.tmp_esperienza === undefined) {
            template = (
                <div className={"row"}>
                    <ModalEsperienza header={"La tua esperienza"}
                                     onCancel={() => this.setState({modal: false})}
                                     onSave={this.addEsperienza.bind(this)}>
                    </ModalEsperienza>
                </div>
            );
        } else {
            template = (
                <div className={"row"}>
                    <ModalEsperienza header={"La tua esperienza"}
                                     esperienza={this.state.tmp_esperienza}
                                     onCancel={() => this.setState({modal: false})}
                                     onEdit={this.updateEsperienza.bind(this)}>
                    </ModalEsperienza>
                </div>
            );
        }
        return (
            template
        );
    }

    updateScuolaFreq(scuola) {
        console.log('scuola frequentata: ', scuola);
        this.setState({scuola_frequentata: scuola});

        const elm = document.querySelector('.register-scuola-scelta');

        if(elm != null) {
            this.scrollIt(elm, 500);
        }

    }

    copyUserTo() {

        const {
            nome,
            cognome,
            email,
            telefono_pfx,
            telefono_num,
            copyTo
        } = this.state;

        switch(copyTo) {
            case 'animatore':
                this.setState({
                    _animatore_nome: nome,
                    _animatore_cognome: cognome,
                    _animatore_email: email,
                    _animatore_telefono: telefono_pfx + telefono_num
                });
                break;
            case 'preside':
                this.setState({
                    _preside_nome: nome,
                    _preside_cognome: cognome,
                    _preside_email: email,
                    _preside_telefono: telefono_pfx + telefono_num
                });
                break;
            case 'segretaria':
                this.setState({
                    _segretaria_nome: nome,
                    _segretaria_cognome: cognome,
                    _segretaria_email: email,
                    _segretaria_telefono: telefono_pfx + telefono_num
                });
                break;
        }

    }

    getScuolaFreq() {

        const provinceArray = shared.provincia.map((item) => {
            return {
                key: item.id,
                value: item.provincia
            }
        })


        console.log('qui', this.state);

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Scuola frequentata</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Indicaci la tua ultima scuola frequentata</h3>
                                {
                                    this.state.scuola_frequentata &&
                                    <div className={"answer"}>
                                        <div className={"listelement"}>
                                            <span>{ this.state.scuola_frequentata.name }</span>
                                            <i className={"icon-delete"} onClick={() => this.setState({ scuola_frequentata: null })}></i>
                                        </div>
                                    </div>
                                }
                            </div>
                        </article>
                        <article>
                            <SceltaScuola province={provinceArray} onSelected={this.updateScuolaFreq.bind(this)} showModal={() => { this.setState({ modal: true }) } } selected={ this.state.scuola_frequentata } type={'Studente'} />
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                    { this.state.modal && this.getModalAggiungiScuola() }
                </div>
            </div>
        );
    }

    getRichiestaGestioneScuola() {

        const provinceArray = shared.provincia.map((item) => {
            return {
                key: item.id,
                value: item.provincia
            }
        })


        console.log('qui', this.state);
        
        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form register-scuola-scelta">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3>Scuola da gestire</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>La scuola che vuoi gestire è</h3>
                                {
                                    this.state.scuola_frequentata &&
                                    <div className={"answer"}>
                                        <div className={"listelement"}>
                                            <span>
                                                <strong>{ this.state.scuola_frequentata && this.state.scuola_frequentata.name }</strong><br />
                                                { this.state.scuola_frequentata && this.state.scuola_frequentata.indirizzo_completo }
                                            </span>
                                            <i className={"icon-delete"} onClick={() => this.setState({ scuola_frequentata: null })}></i>
                                        </div>
                                    </div>
                                }
                            </div>
                        </article>
                        <article>
                            <SceltaScuola province={provinceArray} onSelected={this.updateScuolaFreq.bind(this)} showModal={() => { this.setState({ modal: true }) } } selected={ this.state.scuola_frequentata } type={'Gestore'} />
                        </article>
                        { this.getStepBottomBar() }
                    </section>
                    { this.state.modal && this.getModalAggiungiScuola() }
                </div>
            </div>
        );
    }

    getGestioneScuola() {

        let isTaxRequired = (this.state.scuola_frequentata !== undefined && this.state.scuola_frequentata !== null && this.state.scuola_frequentata.isPubblico === false);

        return (
            <div className="row">
                <div className="boxed-div">
                    <div className="vertical_line"></div>
                    <section className="boxed-form register-form">
                        <header>
                            <span className="icon-attention_filled header-icon"></span>
                            <h3 className={"grey_h3"}>Richiesta gestione della scuola { (this.state.scuola_frequentata.hasOwnProperty('name')) ? this.state.scuola_frequentata.name : '' }</h3>
                        </header>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Dati dell'animatore digitale/responsabile</h3>
                                <div className={"me-btn"} onClick={() => {
                                    const {
                                        nome,
                                        cognome,
                                        user: { email },
                                        telefono_pfx,
                                        telefono_num,
                                    } = this.state;

                                    this.setState({
                                        _animatore_nome: nome,
                                        _animatore_cognome: cognome,
                                        _animatore_email: email,
                                        _animatore_telefono: telefono_pfx + telefono_num
                                    });

                                    document.getElementsByName('_animatore_nome')[0].value = nome;
                                    document.getElementsByName('_animatore_cognome')[0].value = cognome;
                                    document.getElementsByName('_animatore_email')[0].value = email;
                                    document.getElementsByName('_animatore_telefono')[0].value = telefono_pfx + telefono_num;

                                } } >SONO IO</div>
                                <div className={"answer"}>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Nome"} placeholder={"Nome"} required name={"_animatore_nome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Cognome"} placeholder={"Cognome"} required name={"_animatore_cognome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"email"} label={"Indirizzo e-mail"} placeholder={"Indirizzo e-mail"} required name={"_animatore_email"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"tel"} label={"Telefono"} placeholder={"Telefono"} required name={"_animatore_telefono"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Orari di contatto / note"} placeholder={"Orari di contatto"} name={"_animatore_note"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                                <p>questi dati non saranno mai resi pubblici</p>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Dati del preside o amministratore</h3>
                                <div className={"me-btn"} onClick={() => {
                                    const {
                                        nome,
                                        cognome,
                                        user: { email },
                                        telefono_pfx,
                                        telefono_num,
                                    } = this.state;

                                    this.setState({
                                        _preside_nome: nome,
                                        _preside_cognome: cognome,
                                        _preside_email: email,
                                        _preside_telefono: telefono_pfx + telefono_num
                                    });

                                    document.getElementsByName('_preside_nome')[0].value = nome;
                                    document.getElementsByName('_preside_cognome')[0].value = cognome;
                                    document.getElementsByName('_preside_email')[0].value = email;
                                    document.getElementsByName('_preside_telefono')[0].value = telefono_pfx + telefono_num;

                                } } >SONO IO</div>
                                <div className={"answer"}>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Nome"} placeholder={"Nome"} required name={"_preside_nome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Cognome"} placeholder={"Cognome"} required name={"_preside_cognome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"email"} label={"Indirizzo e-mail"} placeholder={"Indirizzo e-mail"} required name={"_preside_email"} onChange={this.handleChange.bind(this)}  />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"tel"} label={"Telefono"} placeholder={"Telefono"} required name={"_preside_telefono"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Orari di contatto / note"} placeholder={"Orari di contatto del preside"} name={"_preside_note"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className={"block-qa"}>
                                <h3>Riferimenti segreteria</h3>
                                <div className={"me-btn"} onClick={() => {
                                    const {
                                        nome,
                                        cognome,
                                        user: { email },
                                        telefono_pfx,
                                        telefono_num,
                                    } = this.state;

                                    this.setState({
                                        _segreteria_nome: nome,
                                        _segreteria_cognome: cognome,
                                        _segreteria_email: email,
                                        _segreteria_telefono: telefono_pfx + telefono_num
                                    });

                                    document.getElementsByName('_segreteria_nome')[0].value = nome;
                                    document.getElementsByName('_segreteria_cognome')[0].value = cognome;
                                    document.getElementsByName('_segreteria_email')[0].value = email;
                                    document.getElementsByName('_segreteria_telefono')[0].value = telefono_pfx + telefono_num;

                                } } >SONO IO</div>
                                <div className={"answer"}>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Nome"} placeholder={"Nome"} required name={"_segreteria_nome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Cognome"} placeholder={"Cognome"} required name={"_segreteria_cognome"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"} style={{marginBottom: "0px"}}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"email"} label={"Indirizzo e-mail"} placeholder={"Indirizzo e-mail"} required name={"_segreteria_email"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"tel"} label={"Telefono"} placeholder={"Telefono"} required name={"_segreteria_telefono"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-6"}>
                                            <FormInput type={"text"} label={"Orari di contatto / note"} placeholder={"Orari segreteria"} name={"_segreteria_note"} onChange={this.handleChange.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        {
                            isTaxRequired &&
                            <article>
                                <div className={"block-qa"}>
                                    <h3>Dati fiscali della sede</h3>
                                    <div className={"answer"}>
                                        <div className={"row"} style={{marginBottom: "0px"}}>
                                            <div className={"col-md-6"}>
                                                <FormInput type={"text"} label={"Ragione Sociale"} placeholder={"Ragione Sociale"} required={ isTaxRequired } name={"_fiscali_ragione_sociale"} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-md-6"}>
                                                <FormInput type={"text"} label={"Partita IVA"} placeholder={"Partita IVA"} required={ isTaxRequired } name={"_fiscali_partita_iva"} onChange={this.handleChange.bind(this)} />
                                            </div>
                                            <div className={"col-md-6"}>
                                                <FormInput type={"text"} label={"Codice Fiscale"} placeholder={"Codice Fiscale"} required={ isTaxRequired } name={"_fiscali_codice_fiscale"} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        }
                        { this.getStepBottomBar() }
                    </section>
                </div>
            </div>
        );
    }

    getAccordionRow(step, label, goToStep) {

        if(goToStep === this.state.step) {
            return (
                <div className="row" >
                    <div className="boxed-div box-accordion" id={"profile-step-" + step}>
                        <section className="boxed-form accordion open box-active-accordion" >
                            {label}
                        </section>
                        {/*<div className="vertical_right_line"></div>*/}
                        <div className="arrow-line">
                            <span className="icon-collapse_arrow"> </span>
                        </div>
                    </div>
                </div>
            );
        }

        const availableSteps = this.steps[this.props.account-1];

        if( (availableSteps.indexOf(goToStep) === -1 || step === 99) || step !== this.state.step ) {
            return (
                <span style={{ display: 'none' }} ></span>
            )
        }

        const status = (availableSteps.indexOf(goToStep) === -1 || step === 99) ? 'closed' : 'open';

        {/*<div className="row" onClick={ () => { console.log('go to step', goToStep); this.goToStep(goToStep) } } >*/}

        return (

            <div className="row" >
                <div className="boxed-div box-accordion" id={"profile-step-" + step}>
                    <section className={(status === 'open') ? "boxed-form accordion open" : "boxed-form accordion" } >
                        {label}
                    </section>
                    {/*<div className="vertical_right_line"></div>*/}
                    <div className="arrow-line">
                        <span className="icon-expand_arrow" onClick={ () => { console.log('go to step', goToStep); this.goToStep(goToStep) } }> </span>
                    </div>
                </div>
            </div>
        );
    }


    scrollIt(destination, duration = 200, easing = 'linear', callback) {

        const easings = {
            linear(t) {
                return t;
            },
            easeInQuad(t) {
                return t * t;
            },
            easeOutQuad(t) {
                return t * (2 - t);
            },
            easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            },
            easeInCubic(t) {
                return t * t * t;
            },
            easeOutCubic(t) {
                return (--t) * t * t + 1;
            },
            easeInOutCubic(t) {
                return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            },
            easeInQuart(t) {
                return t * t * t * t;
            },
            easeOutQuart(t) {
                return 1 - (--t) * t * t * t;
            },
            easeInOutQuart(t) {
                return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
            },
            easeInQuint(t) {
                return t * t * t * t * t;
            },
            easeOutQuint(t) {
                return 1 + (--t) * t * t * t * t;
            },
            easeInOutQuint(t) {
                return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
            }
        };

        const start = window.pageYOffset;
        const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
        const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

        if ('requestAnimationFrame' in window === false) {
            window.scroll(0, destinationOffsetToScroll);
            if (callback) {
                callback();
            }
            return;
        }

        function scroll() {
            const now = 'now' in window.performance ? performance.now() : new Date().getTime();
            const time = Math.min(1, ((now - startTime) / duration));
            const timeFunction = easings[easing](time);
            window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

            if (window.pageYOffset === destinationOffsetToScroll) {
                if (callback) {
                    callback();
                }
                return;
            }

            requestAnimationFrame(scroll);
        }

        scroll();
    }

    render() {

        const account = this.props.account-1;
        let template = null;
        
        let title = null;

        switch(account) {
            case 0:

                title = (
                    <div className="row headline">
                        {/*<h3>Free Classified Using Them To Promote Your Stuff Online </h3>
                        <br />
                        <h5>How to mantain your mental health</h5>*/}
                    </div>
                );
                
                template = (
                    <div className="modulo_Registrazione">
                        {this.state.step != 99 && title }
                        {this.getAccordionRow(this.state.step, 'Anagrafica', 1) } { (this.state.step == 1 && this.getAnagrafica()) }

                        {this.state.step == 99 &&  (
                            <Message action={"Vai alla tua dashboard"} title={"Congratulazioni!"} image={"/static/img/congrats.png"}
                                     icon={'icon-test_passed'} iconSize={"6em"} iconColor={"#FA6A00"}
                                     pretitle={"Il tuo profilo è OK!"}
                                     post={"Potrai modificare il tuo profilo in qualsiasi momento dalla tua dashboard."}
                                     actionicon={"icon-dashboard"}
                                     onClick={() => this.backAllStep()}></Message>)
                        }
                    </div>
                );
                break;
            case 1:

                title = (
                    <div className="row headline">
                        {/*<h3>Free Classified Using Them To Promote Your Stuff Online </h3>
                        <br />
                        <h5>How to mantain your mental health</h5>*/}
                    </div>
                );

                template = (
                    <div className="modulo_Registrazione">
                        {this.state.step != 99 && title }
                        {this.getAccordionRow(this.state.step, 'Anagrafica', 1) } { (this.state.step == 1 && this.getAnagrafica()) }
                        {/*this.getAccordionRow(this.state.step, 'Scuola Frequentata', 17)}  { (this.state.step == 17 &&  this.getScuolaFreq()) */}
                        {this.state.step == 99 &&  (
                            <Message action={"Vai alla tua dashboard"} title={"Congratulazioni!"} image={"/static/img/congrats.png"}
                                     icon={'icon-test_passed'} iconSize={"6em"} iconColor={"#FA6A00"}
                                     pretitle={"Il tuo profilo è OK!"}
                                     post={"Potrai modificare il tuo profilo in qualsiasi momento dalla tua dashboard."}
                                     actionicon={"icon-dashboard"}
                                     onClick={() => this.backAllStep()}></Message>)
                        }
                    </div>
                );
                   break;
            case 2:

                title = (
                    <div className="row headline">
                        {/*<h3>Free Classified Using Them To Promote Your Stuff Online </h3>
                        <br />
                        <h5>How to mantain your mental health</h5>*/}
                    </div>
                );

                template = (
                    <div className="modulo_Registrazione">
                        {this.state.step != 99 && title }
                        {this.getAccordionRow(this.state.step, 'Anagrafica', 1) } { (this.state.step == 1 && this.getAnagrafica()) }
                        {this.getAccordionRow(this.state.step, 'Materie', 11) } { (this.state.step == 11 &&  this.getMaterie()) }
                        {this.getAccordionRow(this.state.step, 'Lezioni Private', 12)}  { (this.state.step == 12 &&  this.getLezioniPrivate()) }
                        {this.getAccordionRow(this.state.step, 'Descrizione', 6) } { (this.state.step == 6 && this.getDescrizione()) }
                        {this.getAccordionRow(this.state.step, 'Formazione', 15) } { (this.state.step == 15 &&  this.getFormazioneP()) }
                        {this.getAccordionRow(this.state.step, 'Lingue', 14) } { (this.state.step == 14 &&  this.getLingue()) }
                        {this.getAccordionRow(this.state.step, 'Esperienze', 16) } { (this.state.step == 16 &&  this.getEsperienze()) }
                        {this.state.step == 99 &&  (
                            <>
                            <Message action={"Vai alla tua dashboard"} title={"Congratulazioni!"} image={"/static/img/congrats.png"}
                                     icon={'icon-test_passed'} iconSize={"6em"} iconColor={"#FA6A00"}
                                     pretitle={"Il tuo profilo è OK!"}
                                     post={"Potrai modificare il tuo profilo in qualsiasi momento dalla tua dashboard."}
                                     actionicon={"icon-dashboard"}
                                     onClick={() => this.backAllStep()}>
                                <h4 className="description">Per rendere più completo il tuo profilo compila subito il calendario disponibilità</h4>
                                <div className="button-bottom">
                                    <button className="btn btn-orange-image" onClick={() => { document.location.href = "/profile/user/calendario"; }}><span className="icon-calendar"></span>Vai al calendario</button>
                                </div>
                            </Message>
                            </>
                        )}
                    </div>
                );
                   break;
            case 3:

                title = (
                    <div className="row headline">
                        {/*<h3>Free Classified Using Them To Promote Your Stuff Online </h3>
                        <br />
                        <h5>How to mantain your mental health</h5>*/}
                    </div>
                );

                template = (
                    <div className="modulo_Registrazione">
                        {this.state.step != 99 && title }
                        {this.getAccordionRow(this.state.step, 'Anagrafica', 1) } { (this.state.step == 1 && this.getAnagrafica()) }
                        {this.getAccordionRow(this.state.step, 'Mini Cv', 7)}  { (this.state.step == 7 && this.getMiniCv()) }
                        {this.getAccordionRow(this.state.step, 'Lavorare', 9) } { (this.state.step == 9 && this.getLavorare()) }
                        {this.getAccordionRow(this.state.step, 'Tariffa', 10) } { (this.state.step == 10 && this.getTariffa()) }
                        {this.getAccordionRow(this.state.step, 'Altre Info', 8)}  { (this.state.step == 8 && this.getAltreInfo()) }
                        {this.getAccordionRow(this.state.step, 'Formazione', 2) } { (this.state.step == 2 &&  this.getFormazione()) }
                        {this.getAccordionRow(this.state.step, 'Descrizione', 6) } { (this.state.step == 6 && this.getDescrizione()) }
                        {this.state.step == 99 &&  (
                            <Message action={"Vai alla tua dashboard"} title={"Congratulazioni!"} image={"/static/img/congrats.png"}
                                icon={'icon-test_passed'} iconSize={"6em"} iconColor={"#FA6A00"}
                                pretitle={"Il tuo profilo è OK!"}
                                post={"Potrai modificare il tuo profilo in qualsiasi momento dalla tua dashboard."}
                                actionicon={"icon-dashboard"}
                                onClick={() => this.backAllStep()}>
                                <h4 className="description">Per rendere più completo il tuo profilo compila subito il calendario disponibilità</h4>
                                <div className="button-bottom">
                                    <button className="btn btn-orange-image" onClick={() => { document.location.href = "/profile/user/disponibilita"; }}><span className="icon-calendar"></span>Vai al calendario</button>
                                </div>
                            </Message>)
                        }
                    </div>
                );
                   break;
            case 4:
                        
                title = (
                    <div className="row headline">
                        {/*<h3>Free Classified Using Them To Promote Your Stuff Online </h3>
                        <br />
                        <h6>How to mantain your mental health</h6>*/}
                    </div>
                );
                template = (
                    <div className="modulo_Registrazione">
                        {this.state.step != 99 && title }
                        {this.getAccordionRow(this.state.step, 'Anagrafica', 1) } { (this.state.step == 1 && this.getAnagrafica()) }
                        {this.getAccordionRow(this.state.step, 'Scuola da gestire', 19)}  { (this.state.step == 19 &&  this.getRichiestaGestioneScuola()) }
                        {this.state.scuola_frequentata && 
                        <>
                            {this.getAccordionRow(this.state.step, 'Contatti scuola', 18)}  { (this.state.step == 18 &&  this.getGestioneScuola()) }
                        </>
                        }

                        {this.state.step == 99 && (
                            <Message
                                action={"Vai alla tua dashboard"}
                                title={"Congratulazioni"}
                                description={"finalmente la tua scuola è tornata a casa: ora puoi prenderti cura di lei."} image={"/static/img/congrats.png"}
                                icon={'icon-test_passed'} iconSize={"6em"} iconColor={"#FA6A00"}
                                post={"Potrai modificare il tuo profilo in qualsiasi momento dalla tua dashboard."}
                                actionicon={"icon-dashboard"}
                                onClick={() => this.backAllStep()}
                                preButton={"Prenditi cura della tua scuola"}
                                preOnClick={() => this.goEditSchool(this.state.scuola_frequentata.id)}
                            ></Message>)
                        }
                    </div>
                );
                   break;
        }

        return (template);
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/ModuloRegistrazione.tsx